import React from 'react';

// Hebrew translations
export const hebrewTranslations = {
  // ========== ניווט ופריסה ==========
  myProfile: "הפרופיל שלי",
  title: "דואליטי - פלטפורמת טורנירים למשחקים",
  admin: "ניהול",
  welcome: "ברוכים הבאים",
  points: "נקודות",
  logout: "התנתקות",
  tournaments: "טורנירים",
  pointsProfile: "נקודות ופרופיל",
  matchHistory: "היסטוריית משחקים",
  adminPanel: "פאנל ניהול",
  approverPanel: "פאנל מאשרים",
  supervisorPanel: "פאנל פיקוח",
  managerPanel: "פאנל מנהל",
  login: "התחברות",
  register: "הרשמה כאן",
  dontHaveAccount: "אין לך חשבון?",
  language: "שפה",
  liveChat: "צ'אט חי",
  menu: "תפריט",
  publicProfile: "ציבורי",
  levelsBadges: "רמה והתקדמות",

  // ========== אימות ==========
  username: "שם משתמש",
  password: "סיסמה",
  email: "אימייל",
  inGameName: "שם במשחק",
  backToLogin: "חזרה להתחברות",
  createAccount: "יצירת חשבון",
  loginSuccessful: "התחברות בוצעה בהצלחה!",
  welcomeBattlefield: "ברוכים הבאים לשדה הקרב!",
  registrationSuccessful: "הרשמה בוצעה בהצלחה!",
  logoutSuccessful: "התנתקות בוצעה בהצלחה",
  loggingIn: "מתחבר...",
  creatingAccount: "יוצר חשבון...",

  // ========== אימות שדות ==========
  loginSubtitle: "התחבר לחשבונך",
  fillAllFields: "מלא את כל השדות ליצירת חשבון",
  enterUsername: "הזן שם משתמש",
  enterPassword: "הזן סיסמה",
  enterEmail: "הזן כתובת אימייל",
  enterInGameName: "Enter your in-game name",
  reenterPassword: "הזן סיסמה שנית",
  confirmPassword: "אימות סיסמה",

  // שגיאות אימות
  usernameRequired: "שם משתמש נדרש",
  usernameTooShort: "שם משתמש חייב להכיל לפחות 3 תווים",
  usernameTooLong: "שם משתמש חייב להיות פחות מ-20 תווים",
  usernameNoHebrew: "שם משתמש לא יכול להכיל תווים בעברית",
  usernameNoArabic: "שם משתמש לא יכול להכיל תווים בערבית",
  usernameInvalidChars: "שם משתמש יכול להכיל רק אותיות, מספרים, קו תחתון ומקף",
  emailRequired: "אימייל נדרש",
  emailInvalid: "אנא הזן כתובת אימייל תקינה",
  inGameNameRequired: "שם במשחק נדרש",
  inGameNameTooShort: "שם במשחק חייב להכיל לפחות 2 תווים",
  inGameNameTooLong: "שם במשחק חייב להיות פחות מ-30 תווים",
  passwordRequired: "סיסמה נדרשת",
  passwordTooShort: "סיסמה חייבת להכיל לפחות 6 תווים",
  passwordTooLong: "סיסמה חייבת להיות פחות מ-50 תווים",
  passwordNeedsNumber: "סיסמה חייבת להכיל לפחות מספר אחד",
  passwordNeedsLetter: "סיסמה חייבת להכיל לפחות אות אחת",
  confirmPasswordRequired: "אנא אשר את הסיסמה",
  passwordsDoNotMatch: "הסיסמאות לא תואמות",

  // הצלחת אימות
  usernameValid: "שם משתמש תקין",
  emailValid: "אימייל תקין",
  inGameNameValid: "שם במשחק תקין",
  passwordValid: "סיסמה תקינה",
  passwordsMatch: "הסיסמאות תואמות",

  // דרישות סיסמה
  min6Chars: "לפחות 6 תווים",
  hasLetter: "מכיל אות",
  hasNumber: "מכיל מספר",

  // שגיאות התחברות
  invalidCredentials: "שם משתמש או סיסמה שגויים",
  userNotFound: "משתמש לא נמצא. בדוק את שם המשתמש.",
  wrongPassword: "סיסמה שגויה. נסה שוב.",
  accountDisabled: "החשבון שלך הושבת. פנה לתמיכה.",
  loginFailed: "ההתחברות נכשלה. נסה שוב.",
  registrationFailed: "ההרשמה נכשלה. נסה שוב.",

  
  // ========== PASSWORD RECOVERY ==========
  forgotPassword: "שכחת סיסמה?",
  forgotPasswordTitle: "שכחתי סיסמה",
  forgotPasswordSubtitle: "הזן את כתובת האימייל שלך ונשלח לך קישור לאיפוס הסיסמה.",
  sendResetLink: "שלח קישור לאיפוס",
  sending: "שולח...",
  checkYourEmail: "בדוק את האימייל שלך",
  resetLinkSent: "אם קיים חשבון עם האימייל הזה, תקבל קישור לאיפוס סיסמה בקרוב. אנא בדוק גם את תיקיית הספאם.",
  linkExpiresIn: "הקישור יפוג תוך שעה.",
  resetPassword: "אפס סיסמה",
  resetPasswordTitle: "איפוס סיסמה",
  resetPasswordSubtitle: "הזן את הסיסמה החדשה שלך למטה.",
  newPassword: "סיסמה חדשה",
  confirmNewPassword: "אשר סיסמה",
  enterNewPassword: "הזן סיסמה חדשה",
  confirmNewPasswordPlaceholder: "אשר סיסמה חדשה",
  resetting: "מאפס...",
  passwordResetSuccess: "הסיסמה אופסה!",
  passwordResetSuccessMessage: "הסיסמה שלך אופסה בהצלחה.",
  redirectingToLogin: "מעביר לדף ההתחברות...",
  loginNow: "התחבר עכשיו",
  invalidResetLink: "קישור לא תקין",
  invalidResetLinkMessage: "קישור איפוס הסיסמה הזה אינו תקין או שפג תוקפו.",
  resetLinkExpiredNote: "קישורי איפוס פגים לאחר שעה מטעמי אבטחה.",
  requestNewResetLink: "בקש קישור איפוס חדש",
  verifyingResetLink: "מאמת קישור איפוס...",

// ========== מערכת רמות ליבה ==========
  level: "רמה",
  levels: "רמות",
  experience: "ניסיון",
  exp: "ניסיון",
  totalExp: "סך כל הניסיון",
  expNeeded: "ניסיון נדרש",
  expToNext: "ניסיון לרמה הבאה",
  expGained: "ניסיון שהושג",
  expReward: "פרס ניסיון",
  currentLevel: "רמה נוכחית",
  nextLevel: "רמה הבאה",
  maxLevel: "רמה מקסימלית!",
  levelUp: "עליית רמה!",
  levelProgress: "התקדמות רמה",
  levelSystem: "מערכת רמות",
  loadingLevel: "טוען רמה...",
  levelTooltip: "רמה {level} - {title}\n{totalExp} סך כל הניסיון\n{remaining}",
  
  // ========== תארי רמות ==========
  beginner: "מתחיל",
  novice: "טירון",
  intermediate: "בינוני",
  advanced: "מתקדם", 
  professional: "מקצועי",
  expert: "מומחה",
  master: "אמן",
  grandmaster: "אמן גדול",
  mythic: "מיתי",
  sage: "חכם",
  legend: "אגדה",
  
  // ========== מערכת תגים ==========
  badges: "תגים",
  badge: "תג",
  earnedBadges: "הושגו",
  inProgress: "בתהליך",
  allBadges: "הכל",
  loadingBadges: "טוען תגים...",
  noBadges: "אין תגים עדיין",
  badgeUnlocked: "תג נפתח!",
  badgeProgress: "התקדמות תג",
  badgeModal: "פרטי תג",
  comingSoon: "בקרוב",
  systemLoading: "המערכת טוענת...",
  noBadgesYet: "אין תגים עדיין",
  characterCount: "{count}/1000",
  progressPercentage: "{percentage}% הושלם",
  currentProgress: "התקדמות נוכחית",
  
  // ========== קטגוריות תגים ==========
  allCategories: "כל הקטגוריות",
  winStreak: "רצף ניצחונות",
  filler: "מילוי",
  totalWins: "סך ניצחונות",
  pointsWinning: "נקודות מניצחונות",
  pointsPurchase: "רכישת נקודות",
  multiplayer: "מולטי פלייר",
  battleRoyale: "בטל רויאל",
  multiplayerWins: "ניצחונות מולטי פלייר",
  battleRoyaleWins: "ניצחונות בטל רויאל",
  
  // ========== נדירות תגים ==========
  common: "רגיל",
  rare: "נדיר",
  epic: "אפי",
  legendary: "אגדי",
  
  // ========== מודאל תג ==========
  close: "סגור",
  category: "קטגוריה",
  requirement: "דרישה",
  unlocked: "נפתח",
  unlockedOn: "נפתח ב",
  progress: "התקדמות",
  remaining: "נותר",
  tip: "טיפ",
  gotIt: "הבנתי!",
  
  // ========== מחווני התקדמות ==========
  complete: "הושלם",
  completion: "השלמה",
  showMore: "הצג עוד",
  showLess: "הצג פחות",
  upcoming: "בקרוב",
  upcomingMilestones: "אבני דרך קרובות",
  congratsMaxLevel: "מזל טוב! הגעת לרמה המקסימלית!",
  totalExpEarned: "סך כל הניסיון שהושג",
  progressDetails: "פרטי התקדמות",
  expForCurrentLevel: "ניסיון ברמה הנוכחית",
  expForNextLevel: "ניסיון לרמה הבאה",
  progressToNext: "התקדמות לרמה הבאה",
  
  // ========== מחווני סטטוס ==========
  loading: "טוען...",
  loadingProgress: "טוען התקדמות...",
  offline: "לא מחובר",
  online: "מחובר",
  
  // ========== טיפים לתגים ==========
  winStreakTip: "המשך לנצח במשחקים ברצף כדי להגיע לאבן הדרך הזו! אתה צריך עוד {remaining} ניצחונות ברצף.",
  totalWinsTip: "נצח בעוד טורנירים כדי לפתוח את התג הזה. עוד {remaining} ניצחונות לדרך!",
  pointsWinningTip: "הרוויח עוד נקודות מניצחונות בטורנירים. אתה צריך עוד {remaining} נקודות.",
  pointsPurchaseTip: "רכוש עוד נקודות כדי לפתוח את התג הזה. נותר לקנות {remaining} נקודות.",
  fillerTip: "הוסף שחקני מילוי לטורנירים וקווה שינצחו! נדרשים עוד {remaining} ניצחונות מילוי.",
  multiplayerTip: "שחק בעוד טורנירי מולטי פלייר. נותרו {remaining} משחקים.",
  battleRoyaleTip: "השתתף בעוד משחקי בטל רויאל. עוד {remaining} משחקים בדרך.",
  multiplayerWinsTip: "נצח בעוד טורנירי מולטי פלייר. נדרשים {remaining} ניצחונות.",
  battleRoyaleWinsTip: "נצח בעוד משחקי בטל רויאל. {remaining} ניצחונות לפתיחה.",
  genericTip: "המשך לשחק כדי לפתוח את התג הזה! עוד {remaining} בדרך.",
  
  // ========== התראות עליית רמה ==========
  levelUpNotification: "עליית רמה!",
  levelUpTitle: "מזל טוב!",
  levelUpSubtitle: "הגעת לרמה חדשה!",
  newLevelUnlocked: "רמה חדשה נפתחה",
  titleEarned: "תואר הושג",
  
  // ========== סטטיסטיקות ==========
  statistics: "סטטיסטיקות",
  totalEarned: "סך הכל הושג",
  totalAvailable: "סך הכל זמין",
  completionPercentage: "אחוז השלמה",
  earnedCount: "מספר שהושגו",
  progressCount: "מספר בתהליך",
  
  // ========== הודעות הישג ==========
  achievementUnlocked: "הישג נפתח!",
  newBadgeEarned: "תג חדש הושג!",
  levelMilestone: "אבן דרך של רמה!",
  experienceGained: "ניסיון הושג: +{amount}",
  
  // ========== הודעות שגיאה ==========
  failedToLoadBadges: "נכשל בטעינת התגים",
  failedToLoadLevel: "נכשל בטעינת הרמה",
  failedToLoadProgress: "נכשל בטעינת ההתקדמות",
  
  // ========== כפתורי פעולה ==========
  viewDetails: "צפה בפרטים",
  trackProgress: "עקוב אחר התקדמות",
  shareAchievement: "שתף הישג",
  
  // ========== התראות ==========
  badgeEarned: "תג הושג: {badgeName}",
  levelIncreased: "עליית רמה! עכשיו רמה {level}",
  milestoneReached: "אבן דרך הושגה!",
  
  // ========== תצוגות קומפקטיות ==========
  lvl: "רמה",
  expShort: "נ",
  badgesShort: "תגים",
  
  // ========== פסי התקדמות ==========
  progressBarLabel: "התקדמות: {current}/{total}",
  completionRate: "שיעור השלמה: {percentage}%",
  
  // ========== מבוסס זמן ==========
  recentlyUnlocked: "נפתח לאחרונה",
  timeToUnlock: "זמן לפתיחה",
  earnedToday: "הושג היום",
  earnedThisWeek: "הושג השבוע",
  
  // ========== מסננים ומיון ==========
  filterByCategory: "סנן לפי קטגוריה",
  sortByProgress: "מיין לפי התקדמות",
  sortByRarity: "מיין לפי נדירות",
  sortByDate: "מיין לפי תאריך",
  
  // ========== טקסט עזרה ==========
  howToEarnBadges: "איך להרוויח תגים",
  levelSystemExplanation: "הסבר מערכת הרמות",
  experienceExplanation: "הסבר נקודות ניסיון",
  
  // ========== אירועים מיוחדים ==========
  specialEvent: "אירוע מיוחד",
  limitedTime: "זמן מוגבל",
  eventBadge: "תג אירוע",
  seasonalBadge: "תג עונתי",

  // ========== תרגומי פרופיל ציבורי ==========
  profileTitle: "הפרופיל של {name}",
  playerNotFound: "שחקן לא נמצא",
  profilePrivate: "פרופיל זה פרטי",
  failedToLoadProfile: "נכשל בטעינת הפרופיל",
  playerNotFoundDesc: "השחקן שאתה מחפש לא קיים או נחסם.",
  profilePrivateDesc: "השחקן הזה הגדיר את הפרופיל שלו כפרטי.",
  profileLoadError: "הייתה שגיאה בטעינת הפרופיל. אנא נסה שוב.",
  yourProfile: "הפרופיל שלך",
  searchOtherPlayer: "חפש שחקן אחר",
  findPlayer: "מצא שחקן",
  searchPlayerDesc: "חפש כל שחקן לפי שם המשתמש או השם במשחק כדי לצפות בפרופיל הציבורי שלו.",
  loadingProfile: "טוען פרופיל...",
  loadingPlayerProfile: "טוען פרופיל שחקן...",
  playerProfiles: "פרופילי שחקנים",
  
  // ========== תרגומי לוח מובילים ==========
  wins: "נצחונות",
  avgPrize: "ממוצע",
  totalPrize: "זכיות",
  losses: "הפסדים",
  leaderboard: "לוח מובילים",
  levelLeaderboard: "לוח מובילים לפי רמה",
  winsLeaderboard: "לוח מובילים לפי ניצחונות",
  winStreakLeaderboard: "לוח מובילים לפי רצף ניצחונות",
  pointsLeaderboard: "לוח מובילים לפי נקודות",
  levelLeaderboardDesc: "השחקנים המובילים לפי נקודות ניסיון ורמה",
  winsLeaderboardDesc: "השחקנים המובילים לפי סך ניצחונות בטורנירים",
  winStreakLeaderboardDesc: "השחקנים המובילים עם רצפי ניצחונות נוכחיים",
  pointsLeaderboardDesc: "השחקנים המובילים לפי יתרת נקודות נוכחית",
  loadingLeaderboard: "טוען לוח מובילים...",
  loadingRankings: "טוען דירוגי שחקנים...",
  failedToLoadLeaderboard: "נכשל בטעינת לוח המובילים",
  leaderboardRefreshed: "לוח המובילים רוענן!",
  leaderboardLoadError: "הייתה שגיאה בטעינת לוח המובילים. אנא נסה שוב.",
  noDataAvailable: "אין נתונים זמינים",
  noActiveStreaks: "אין כרגע לשחקנים רצפי ניצחונות פעילים.",
  noPlayersFound: "לא נמצאו שחקנים עבור לוח מובילים זה.",
  fullRankings: "דירוג מלא",
  champion: "אלוף",
  currentStreak: "רצף נוכחי",
  maxStreak: "מקסימום",
  levelDesc: "לפי ניסיון",
  winsDesc: "לפי ניצחונות",
  winStreakDesc: "רצפים נוכחיים",
  pointsDesc: "לפי יתרה",
  lastUpdated: "עודכן לאחרונה",
  accountAge: "גיל החשבון ",
  days: "ימים",
  you: "(אתה)",
  searchFromLeaderboard: "חפש כל שחקן...",
  
  // ========== רכיבי פרופיל משופרים ==========
  profile: "פרופיל",
  overview: "סקירה",
  mainAdmin: "מנהל ראשי",
  supervisor: "מפקח",
  approver: "מאשר",
  manager: "מנהל",
  verifiedSponsor: "ספונסר מאומת",
  player: "שחקן",
  memberSince: "חבר מאז ",
  lastSeen: "נראה לאחרונה",
  currentlyOnline: "כרגע:",
  fillerWins: "ניצחונות מילוי",
  bestWinStreak: " רצף הנצחונות הטוב היותר ",
  gameModeStats: "סטטיסטיקות מצבי משחק",
  accountInformation: "מידע חשבון",
  funStats: "סטטיסטיקות מעניינות",
  played: "שיחק",
  multiplayerWinRate: "שיעור ניצחונות מולטי פלייר",
  battleRoyaleWinRate: "שיעור ניצחונות בטל רויאל",
  
  // ========== חיפוש וכללי ==========
  search: "חפש",
  searchForPlayer: "חפש שחקן",
  searchPlayerPlaceholder: "חפש לפי שם משתמש או שם במשחק...",
  searching: "מחפש...",
  playersFound: "שחקנים נמצאו",
  noPlayersFoundSearch: "לא נמצאו שחקנים שמתאימים ל\"{query}\"",
  searchTipExact: "נסה לחפש עם שם המשתמש או השם במשחק המדויק",
  searchTipUsername: "חפש לפי שם משתמש (למשל, @player123)",
  searchTipInGame: "חפש לפי שם במשחק (למשל, ProGamer)",
  searchTip: "השתמש ב↑↓ לניווט, Enter לבחירה, Esc לסגירה",
  
  // ========== תגים ופרופיל ספציפי ==========
  badgeCollection: "אוסף תגים",
  earned: "הושג",
  categoryBreakdown: "פירוט קטגוריות",
  achievementSummary: "סיכום הישגים",
  badgeSystemNotAvailable: "מערכת התגים לא זמינה עבור פרופיל זה.",
  badgesPrivateDesc: "השחקן הזה הגדיר את אוסף התגים שלו כפרטי.",
  badgesLoadError: "הייתה שגיאה בטעינת אוסף התגים.",
  badgeSummaryText: "השיג {earned} מתוך {total} תגים זמינים ({percentage}% השלמה). הוא פתח {categories} קטגוריות שונות והשיג סך של {exp} נקודות ניסיון מתגים.",
  recentlyEarned: "הושג לאחרונה",
  showProgress: "הצג התקדמות",
  categoriesUnlocked: "קטגוריות",
  totalExpFromBadges: "סך ניסיון מתגים",
  
  // ========== היסטוריית משחקים ==========
  noMatches: "לא נמצאו משחקים",
  noMatchesDesc: "השחקן הזה עדיין לא השלים משחקים ציבוריים.",
  loadingMatches: "טוען משחקים...",
  total: "סך הכל",
  prizeWon: "פרס שהושג",
  winRate: "שיעור ניצחונות",
  map: "מפה",
  maxKills: "מקסימום הריגות",
  entry: "כניסה",
  prize: "פרס",
  players: "שחקנים",
  by: "על ידי",
  won: "ניצח",
  lost: "הפסיד",
  shared: "משותף",
  thisPlayer: "השחקן הזה",
  matchSummary: "סיכום משחקים",
  winLossRecord: "רקורד ניצחונות/הפסדים",
  totalPrizeWon: "סך הפרס שהושג",
  averagePrize: "פרס ממוצע לניצחון",
  
  // ========== סטטיסטיקות מפורטות ==========
  detailedStatistics: "סטטיסטיקות מפורטות",
  quickStats: "סטטיסטיקות מהירות",
  overallPerformance: "ביצועים כלליים",
  gameModeBreakdown: "פירוט מצבי משחק",
  pointsStatistics: "סטטיסטיקות נקודות",
  specialAchievements: "הישגים מיוחדים",
  playerSummary: "סיכום שחקן",
  playerSummaryText: "הוא שחקן {performance} עם {wins} ניצחונות מתוך {total} משחקים, משיג שיעור ניצחונות של {winRate}%. הוא מדורג כעת במקום #{rank} בעולם.",
  currentStreakText: "הוא כעת ברצף של {streak} ניצחונות!",
  bestStreakText: "רצף הניצחונות הטוב ביותר שלו היה {streak} ניצחונות רצופים.",
  elite: "אליטה",
  pro: "מקצועי",
  average: "ממוצע",
  fillerMaster: "מאסטר מילוי",
  fillerWinsDesc: "ניצח בטורנירים עם מילויי AI",
  streakWarrior: "לוחם רצפים",
  streakDesc: "השיג רצפי ניצחונות מרשימים",
  globalRank: "דירוג עולמי",
  byExperience: "לפי ניסיון",
  currentPoints: "נקודות נוכחיות",
  pointsWon: "נקודות שהושגו",
  pointsLost: "נקודות שאבדו",
  netGain: "רווח נטו",
  avgPerWin: "ממוצע לניצחון",
  fromLosses: "מהפסדים",
  pointsPurchased: "נקודות שנרכשו",
  teamBased: "משחקים קבוצתיים",
  survivalMode: "מצב הישרדות",
  matchesPlayed: "משחקים ששוחקו",
  totalMatches: "סך המשחקים",
  badgesEarned: "תגים שהושגו",
  badgeExp: "ניסיון מתגים",
  categories: "קטגוריות",
  
  // ========== תפקידים ==========
  roleChanged: "התפקיד שלך השתנה",
  commissionEarned: "עמלה שהורווחה",
  matchesApproved: "משחקים שאושרו",
  approversManaged: "מאשרים שנוהלו",
  roleUpdated: "תפקיד עודכן",
  roleChangedTo: "התפקיד שלך השתנה ל",
  changedBy: "שונה על ידי",
  reason: "סיבה",
  commissionRates: "שיעורי עמלה",
  
  // ========== תרגומי ניקוי טורנירים ==========
  oldTournamentRemoved: 'טורניר ישן הוסר אוטומטית',
  tournamentsAutoRemoved: '{count} טורנירים ישנים הוסרו מהלובי',
  pointsRefunded: '{amount} נקודות הוחזרו לשחקנים',
  adminCleanupActivity: 'ניקוי: {deleted} טורנירים הוסרו, {refunded} נקודות הוחזרו',
  manualCleanupTriggered: 'ניקוי ידני על ידי {admin}: {deleted} טורנירים נמחקו',
  autoCleanup: 'ניקוי-אוטומטי',
  removes: 'מסיר',
  old: 'ישן',
  cleanupNow: 'נקה עכשיו',
  active: 'פעיל',
  stopped: 'מופסק',
  onlyMainAdminCanCleanup: 'רק מנהלים ראשיים יכולים להפעיל ניקוי ידני',
  manualCleanupCompleted: 'ניקוי ידני הושלם: {deleted} טורנירים הוסרו',
  manualCleanupFailed: 'ניקוי ידני נכשל',
  tournamentAutoDeleted: 'טורניר נמחק אוטומטית בגלל גיל',
  tournamentDeletedOld: 'טורניר ישן הוסר מהלובי',
  cleanupServiceActive: 'שירות הניקוי פעיל',
  cleanupServiceStopped: 'שירות הניקוי מופסק',
  tournamentCleanupStatus: 'סטטוס ניקוי טורנירים',
  maxAgeInLobby: 'גיל מקסימלי בלובי',
  cleanupInterval: 'מרווח ניקוי',
  lastCleanup: 'ניקוי אחרון',
  nextCleanup: 'ניקוי הבא',
  tournamentsProcessed: 'טורנירים שעובדו',
  totalRefundedAmount: 'סך הכל הוחזר',
  cleanupConfiguration: 'הגדרות ניקוי',
  enableAutoCleanup: 'הפעל ניקוי אוטומטי',
  maxAgeHours: 'גיל מקסימלי (שעות)',
  intervalMinutes: 'מרווח ניקוי (דקות)',
  maxPerRun: 'מקסימום טורנירים בריצה',
  enableNotifications: 'הפעל התראות',
  saveConfiguration: 'שמור הגדרות',
  configurationSaved: 'הגדרות נשמרו בהצלחה',
  configurationFailed: 'שמירת הגדרות נכשלה',
  triggerManualCleanup: 'הפעל ניקוי ידני',
  cleanupInProgress: 'ניקוי בתהליך...',
  cleanupCompleted: 'ניקוי הושלם',
  noOldTournaments: 'לא נמצאו טורנירים ישנים',
  cleanupSummary: 'סיכום ניקוי',
  deletedCount: 'נמחקו',
  refundedAmount: 'הוחזר',
  errors: 'שגיאות',
  duration: 'משך זמן',
  tournamentAgeWarning: 'הטורניר יימחק אוטומטית בעוד {time}',
  tournamentAgeInfo: 'גיל הטורניר: {age}',
  autoDeleteIn: 'מחיקה אוטומטית בעוד',
  minutes: 'דקות',
  hours: 'שעות',
  
  // ========== ניהול מילויים ==========
  fillerManagement: "ניהול מילויים",
  addFiller: "הוסף מילוי",
  fillerPlayers: "שחקני מילוי",
  fillerName: "שם שחקן מילוי",
  enterFillerName: "הכנס שם מילוי...",
  fillerNameRequired: "שם מילוי נדרש",
  fillerNameTooLong: "שם מילוי ארוך מדי (מקסימום 20 תווים)",
  fillerNameHelp: "בחר שם ייחודי לשחקן AI הזה (מקסימום 20 תווים)",
  insufficientPointsForFiller: "אין מספיק נקודות להוספת מילוי",
  fillerAddedSuccessfully: "מילוי \"{name}\" נוסף בהצלחה!",
  failedToAddFiller: "נכשל בהוספת מילוי",
  removeFiller: "הסר מילוי",
  fillerRemoved: "מילוי הוסר בהצלחה!",
  fillerRemovedWithRefund: "מילוי הוסר! {amount} נקודות הוחזרו.",
  failedToRemoveFiller: "נכשל בהסרת מילוי",
  yourFiller: "(המילוי שלך)",
  needMorePoints: "נדרש {amount} נקודות נוספות",
  needMoreRealPlayers: "נדרש {count} שחקנים אמיתיים נוספים לפני הוספת מילויים כשהטורניר מתמלא",
  needRealPlayersWarning: "נדרש {count} שחקנים אמיתיים נוספים כדי להוסיף מילויים כשהטורניר מתמלא",
  free: "חינם",
  cost: "עלות",
  slots: "מקומות",
  slotRemaining: "מקום נותר",
  slotsRemaining: "מקומות נותרים",
  giveawayFillerFree: "זה טורניר חלוקה - מילויים בחינם!",
  fillerCostWarning: "תשלם {cost} נקודות עבור מילוי זה. אם המילוי ינצח, תקבל את הפרס!",
  fillerAddedAndTournamentUpdated: "מילוי נוסף! הטורניר עודכן.",
  
  // ========== פונקציונליות העתקה ==========
  noMatchIdToCopy: "אין מזהה משחק זמין להעתקה",
  matchIdCopied: "מזהה המשחק הועתק ללוח!",
  noTournamentIdToCopy: "אין מזהה טורניר זמין להעתקה",
  tournamentIdCopied: "מזהה הטורניר הועתק ללוח!",
  
  // ========== חיפוש ודפדוף ==========
  searchFinishedTournaments: "חפש לפי מזהה טורניר, יוצר, מצב משחק או מפה...",
  searchResults: "נמצאו {count} טורנירים",
  noSearchResults: "אין תוצאות חיפוש",
  tryDifferentSearch: "נסה מונח חיפוש אחר או נקה את החיפוש",
  previousPage: "עמוד קודם",
  nextPage: "עמוד הבא",
  prev: "קודם",
  next: "הבא",
  pageInfo: "עמוד {current} מתוך {total} ({totalItems} בסה\"כ)",
  
  // ========== פאנל ניהול ==========
  mainAdminPanel: "פאנל מנהל ראשי",
  commissionSummary: "סיכום עמלה",
  yourCommissionEarned: "העמלה שלך שהרווחת",
  asSupervisor: "(כמפקח)",
  asApprover: "(כמאשר)",
  totalFromUsers: "סך הכל ממשתמשים",
  totalToApprovers: "סך הכל למאשרים",
  totalToSystem: "סך הכל למערכת",
  
  // ========== לשוניות ניהול ==========
  stats: "סטטיסטיקות",
  roles: "תפקידים",
  pointsTab: "נקודות",
  rates: "שיעורים",
  users: "משתמשים",
  approvers: "מאשרים",
  inbox: "תיבת דואר",
  pending: "ממתין",
  withdrawals: "משיכות",
  transactionLog: "עסקאות",

  // ========== יומן עסקאות ==========
  totalTransactions: "סה״כ עסקאות",
  pointsIn: "נקודות נכנסות",
  pointsOut: "נקודות יוצאות",
  filters: "מסננים",
  hideFilters: "הסתר",
  showFilters: "הצג",
  transactionType: "סוג",
  searchPlaceholder: "שם משתמש או תיאור...",
  startDate: "תאריך התחלה",
  endDate: "תאריך סיום",
  apply: "החל",
  reset: "איפוס",
  noTransactions: "לא נמצאו עסקאות",
  transactionsWillAppear: "עסקאות נקודות מטורנירים, רכישות ופעולות מנהל יופיעו כאן.",

  // ========== ניהול תפקידים ==========
  userRoleManagement: "ניהול תפקידי משתמשים",
  joinDate: 'תאריך הצטרפות',
  totalActiveTime: 'סה״כ פעילות',
  avgDailyTime: 'ממוצע יומי',
  searchUsersModifyRoles: "חפש משתמשים ושנה את התפקידים שלהם במערכת. רק מנהלים ראשיים יכולים לשנות תפקידי משתמשים.",
  searchUsers: "חיפוש משתמשים",
  searchByUsername: "חפש לפי שם משתמש, אימייל או שם במשחק...",
  searchResultsLabel: "תוצאות חיפוש",
  selectedUser: "משתמש נבחר",
  currentRole: "תפקיד נוכחי",
  newRole: "תפקיד חדש",
  roleChangePreview: "שינוי תפקיד:",
  roleChangeDescription: "שנה תפקיד משתמש",
  reasonForChange: "סיבה לשינוי (אופציונלי)",
  enterReasonForRoleChange: "הכנס סיבה לשינוי התפקיד...",
  changeUserRole: "שנה תפקיד משתמש",
  searchAndSelectUser: "חפש ובחר משתמש לניהול התפקיד שלו",
  rolePermissionsGuide: "מדריך הרשאות תפקידים",
  fullSystemAccess: "גישה מלאה למערכת, יכול לנהל את כל המשתמשים וההגדרות",
  canManageApprovers: "יכול לנהל מאשרים ולאשר טורנירים",
  canApproveTournaments: "יכול לאשר טורנירים ולהרוויח עמלה",
  managerAccess: "הרשאות מפקח בנוסף לחסימת משתמשים וניהול תפקידים",
  verifiedSponsorAccess: "יכול ליצור טורנירי מתנות וטורנירים רב-שלביים",
  regularUser: "משתמש רגיל, יכול להשתתף בטורנירים",
  cannotBeChanged: "⚠️ לא ניתן לשינוי",
  
  // ========== ניהול נקודות ==========
  pointsManagement: "ניהול נקודות",
  searchUsersManagePoints: "חפש משתמשים ונהל את הנקודות שלהם. אתה יכול להוסיף, להסיר או לקבוע כמויות נקודות ספציפיות.",
  actionType: "סוג פעולה",
  add: "הוסף",
  remove: "הסר",
  set: "קבע",
  pointsAmount: "כמות נקודות",
  enterPointsAmount: "הכנס כמות נקודות...",
  reasonOptional: "סיבה (אופציונלי)",
  enterReasonForPointsAdjustment: "הכנס סיבה להתאמת הנקודות...",
  actionAdd: "הוסף",
  actionRemove: "הסר",
  actionSet: "קבע",
  pointsToUser: "נקודות ל",
  pointsFromUser: "נקודות מ",
  pointsForUser: "נקודות עבור",
  newBalance: "יתרה חדשה:",
  addPoints: "הוסף נקודות",
  removePoints: "הסר נקודות",
  setPoints: "קבע נקודות",
  searchAndSelectUserPoints: "חפש ובחר משתמש לניהול הנקודות שלו",

  // ========== שליחת נקודות ==========
  sendPoints: "שלח נקודות",
  sendPointsFromWallet: "שלח נקודות מהארנק שלך למשתמש אחר",
  yourBalance: "היתרה שלך",
  searchRecipient: "חפש נמען",
  recipient: "נמען",
  theirPoints: "הנקודות שלו",
  amountToSend: "כמות לשליחה",
  enterReasonForTransfer: "הכנס סיבה להעברה...",
  sending: "שולח",
  yourNewBalance: "היתרה החדשה שלך",
  insufficientFunds: "אין מספיק כסף",
  searchAndSelectRecipient: "חפש ובחר נמען לשליחת נקודות",
  confirmTransfer: "אשר העברה",
  sendingTo: "שולח ל",
  transferDetails: "פרטי העברה",
  sendingAmount: "שולח",
  pointsTo: "נקודות ל",
  theirNewBalance: "היתרה החדשה שלהם",
  transferWarning: "העברה זו מיידית ולא ניתנת לביטול. הנקודות יקוזזו מהארנק שלך.",
  confirmSend: "אשר שליחה",
  pointsSentSuccessfully: "נשלחו בהצלחה {points} נקודות ל-{username}",
  failedToSendPoints: "שליחת הנקודות נכשלה",
  pointsTransferSent: "נקודות נשלחו",
  pointsTransferReceived: "נקודות התקבלו",

  // ========== הגדרות עמלה ==========
  commissionRateSettings: "הגדרות שיעורי עמלה",
  multiplayerTournaments: "🎯 טורנירי מולטי פלייר",
  battleRoyaleTournaments: "👑 טורנירי בטל רויאל",
  approverCommission: "עמלת מאשר (%)",
  systemCommission: "עמלת מערכת (%)",
  updateCommissionRates: "עדכן שיעורי עמלה",
  updating: "מעדכן...",
  
  // ========== ניהול משתמשים ==========
  allUsers: "כל המשתמשים",
  ban: "חסום",
  unban: "בטל חסימה",
  
  // ========== ניהול מאשרים ==========
  addNewApprover: "הוסף מאשר חדש",
  multiplayerCommissionRange: "עמלת מולטי פלייר (0-{max}%):",
  battleRoyaleCommissionRange: "עמלת בטל רויאל (0-{max}%):",
  addAsApprover: "הוסף כמאשר",
  adding: "מוסיף...",
  myApprovers: "המאשרים שלי",
  noApproversAdded: "עדיין לא נוספו מאשרים.",
  
  // ========== ניהול טורנירים ==========
  matchesReadyForApproval: "משחקים מוכנים לאישור",
  youCanOnlySeeMatches: "ℹ️ אתה יכול לראות רק משחקים שלא נתפסו על ידי {role} אחרים או משחקים שהתחלת לאשר בעבר.",
  supervisors: "מפקחים",
  approversLower: "מאשרים",
  noMatchesReady: "אין משחקים מוכנים לאישור.",
  othersMayHaveClaimed: "{role} אחרים עשויים להיות תפסו משחקים זמינים.",
  enterMatchIdFromCod: "הכנס מזהה משחק מ CoD Mobile",
  approve: "אשר",
  approving: "מאשר...",
  startedBy: "⚠️ הוחל על ידי:",
  assignedToBot: 'מוקצה לבוט',
  
  // ========== משחקים פעילים ==========
  activeMatches: "משחקים פעילים",
  youCanOnlyManageMatches: "ℹ️ אתה יכול לראות ולנהל רק משחקים שאישרת באופן אישי.",
  noActiveMatches: "אין משחקים פעילים.",
  haventApprovedMatches: "עדיין לא אישרת משחקים או שהם הושלמו.",
  roomLabel: "🎮 מזהה חדר",
  generating: "יוצר...",
  noAccess: "🔒 אין גישה",
  notInTournament: "לא בטורניר זה",
  copyId: "העתק מזהה",
  joinRoom: "הצטרף לחדר",
  roomUrl: "קישור לחדר",
  enterRoomUrl: "https://... (קישור אופציונלי להצטרפות לחדר)",
  roomUrlDescription: "אם מסופק, השחקנים יראו כפתור 'הצטרף לחדר'",
  edit: "ערוך",
  cancel: "בטל",
  standby: "⏱️ המתנה",
  activeBadge: "🔥 פעיל",
  joined: "✓ הצטרף",
  selectWinners: "בחר מנצח",
  selectWinnersPlural: "בחר מנצחים",
  readyForSelection: "⚡ מוכן לבחירה",
  completeMatch: "השלם משחק",
  completing: "משלים...",
  winner: "מנצח",
  winners: "מנצחים",
  teamModeInfo: "ℹ️ {mode}: בחר {count} מנצח{plural} מהקבוצה המנצחת",
  duos: "זוגות",
  squads: "חוליות",
  teamMode: "מצב קבוצתי",
  winnerSelectionAvailable: "⚡ בחירת מנצח זמינה עכשיו. הספירה לאחור היא רק המועד האחרון לשחקנים להצטרף.",
  
  // ========== עריכת מזהה משחק ==========
  editMatchId: "ערוך מזהה משחק",
  currentMatchId: "מזהה משחק נוכחי:",
  newMatchId: "מזהה משחק חדש",
  enterNewMatchId: "הכנס מזהה משחק חדש מ CoD Mobile",
  matchIdCannotBeEmpty: "מזהה המשחק לא יכול להיות ריק",
  matchIdTooLong: "מזהה המשחק חייב להיות פחות מ-50 תווים",
  sameAsCurrentMatchId: "מזהה המשחק החדש זהה למזהה המשחק הנוכחי",
  validNewMatchId: "✓ מזהה משחק חדש תקין",
  matchIdHistory: "היסטוריית מזהה משחק:",
  current: "(נוכחי)",
  changingMatchIdNotification: "⚠️ שינוי מזהה המשחק יודיע לכל משתתפי הטורניר. וודא שמזהה המשחק החדש נכון.",
  updateMatchId: "עדכן מזהה משחק",
  updateMatching: "מעדכן...",
  
  // ========== ביטול טורניר ==========
  cancelTournament: "בטל טורניר",
  cancellationReason: "סיבת ביטול",
  enterReasonForCancelling: "הכנס סיבה לביטול הטורניר הזה...",
  refundInformation: "⚠️ מידע החזר:",
  creatorWillReceive: "היוצר יקבל",
  pointsBack: "נקודות בחזרה",
  eachParticipantWillReceive: "כל משתתף יקבל את",
  entryFeeBack: "דמי הכניסה שלו בחזרה",
  totalRefund: "סך החזר",
  giveawayIndicator: "🎁 טורניר חינמי",
  thisActionCannotBeUndone: "⚠️ פעולה זו לא ניתנת לביטול. כל המשתתפים יקבלו החזר והטורניר יבוטל לצמיתות.",
  confirmCancellation: "אשר ביטול",
  cancelling: "מבטל...",
  keepTournament: "שמור טורניר",
  
  // ========== בקשות משיכה ==========
  withdrawalRequests: "בקשות משיכה",
  noPendingRequests: "אין בקשות ממתינות.",
  pointsToAmount: "{points} נקודות → ${amount}",
  
  // ========== מודאלי אישור ==========
  confirmRoleChange: "אשר שינוי תפקיד",
  roleChangeFromTo: "{currentRole} → {newRole}",
  thisActionWillImmediately: "⚠️ פעולה זו תשנה מיד את התפקיד וההרשאות של המשתמש. המשתמש יקבל הודעה על השינוי הזה.",
  confirmChange: "אשר שינוי",
  changingRole: "משנה תפקיד...",
  
  // ========== אישור נקודות ==========
  confirmPointsAction: "אשר פעולת נקודות {action}",
  pointsAction: "פעולה:",
  actionDescription: "{action} {amount} נקודות {preposition} {username}",
  prepositionTo: "ל",
  prepositionFrom: "מ",
  prepositionFor: "עבור",
  thisActionWillUpdatePoints: "⚠️ פעולה זו תעדכן מיד את יתרת הנקודות של המשתמש. וודא שהסכום נכון.",
  confirmAction: "אשר {action}",
  processing: "מעבד...",
  
  // ========== אישור כללי ==========
  changeUserRoleQuestion: "שנה תפקיד?",
  banUserQuestion: "חסום משתמש?",
  unbanUserQuestion: "בטל חסימת משתמש?",
  removeApproverQuestion: "הסר מאשר?",
  
  // ========== התראות והודעות ==========
  roleChangedSuccessfully: "שינוי תפקיד {username} ל{role} בוצע בהצלחה",
  pointsAddedSuccessfully: "הוספת {points} נקודות ל{username} בוצעה בהצלחה",
  pointsRemovedSuccessfully: "הסרת {points} נקודות מ{username} בוצעה בהצלחה",
  pointsSetSuccessfully: "קביעת {points} נקודות עבור {username} בוצעה בהצלחה",
  matchIdUpdatedSuccessfully: "מזהה המשחק עודכן בהצלחה",
  tournamentCancelledSuccessfully: "הטורניר בוטל בהצלחה. {refundInfo}",
  commissionRatesUpdated: "שיעורי העמלה עודכנו בהצלחה!",
  userBannedSuccessfully: "{username} נחסם בהצלחה!",
  userUnbannedSuccessfully: "החסימה של {username} בוטלה בהצלחה!",
  approverAddedSuccessfully: "מאשר נוסף בהצלחה!",
  approverRemovedSuccessfully: "{username} הוסר מתפקיד מאשר בהצלחה!",
  matchApprovedSuccessfully: "המשחק אושר בהצלחה!",
  matchCompletedSuccessfully: "המשחק הושלם בהצלחה!",
  withdrawalProcessedSuccessfully: "בקשת המשיכה {status} בוצעה בהצלחה!",
  
  // ========== הודעות שגיאה ==========
  failedToLoadAdminData: "נכשל בטעינת נתוני ניהול",
  failedToChangeUserRole: "נכשל בשינוי תפקיד משתמש",
  failedToManagePoints: "נכשל בניהול נקודות",
  failedToUpdateMatchId: "נכשל בעדכון מזהה משחק",
  failedToCancelTournament: "נכשל בביטול טורניר",
  failedToUpdateCommissionRates: "נכשל בעדכון שיעורי עמלה",
  failedToProcessWithdrawal: "נכשל בעיבוד משיכה",
  failedToSearchUsers: "נכשל בחיפוש משתמשים",
  invalidUserOrRole: "משתמש או תפקיד לא תקין נבחר",
  userAlreadyHasRole: "למשתמש כבר יש את התפקיד הזה",
  pleaseSelectUser: "אנא בחר משתמש תחילה",
  pleaseEnterValidAmount: "אנא הכנס כמות נקודות תקינה",
  pleaseEnterMatchId: "אנא הכנס מזהה משחק!",
  pleaseSelectWinner: "אנא בחר לפחות מנצח אחד!",
  unknownAction: "פעולה לא ידועה: {action}",
  
  // ========== תוויות וממלאי מקום ==========
  searchResultsCount: "תוצאות חיפוש ({count})",
  
  // ========== מחווני סטטוס ==========
  banned: "חסום",
  approved: "אושר",
  rejected: "נדחה",
  
  // ========== יצירת טורניר ==========
  upTo: 'עד',
  createTournament: "יצירת טורניר",
  tournamentType: "סוג טורניר",
  regularTournament: "🏆 טורניר רגיל",
  giveawayTournament: "🎁 טורניר חינמי (כניסה חופשית)",

  // אפשרויות השתתפות יוצר הגיב-אוואי
  creatorParticipation: "ההשתתפות שלך",
  joinAndPlay: "הצטרף ושחק",
  joinAndPlayDesc: "אתה משתתף במשחק",
  spectateGame: "צפה במשחק",
  spectateGameDesc: "צפה במשחק כצופה",
  sponsorOnly: "נותן חסות בלבד",
  sponsorOnlyDesc: "רק ממן את הפרס, אחרים משחקים",
  spectateInfo: "תהיה במשחק כצופה. תוכל לצפות אבל לא לשחק. כל המקומות פתוחים לאחרים.",
  sponsorInfo: "לא תתווסף למשחק. כל המקומות פתוחים לשחקנים אחרים להצטרף בחופשיות.",
  spectator: "צופה",

  gameMode: "מצב משחק",
  multiplayerFilter: "🎯 Multiplayer",
  battleRoyaleFilter: "👑 BattleRoyale",
  multiplayerType: "סוג משחק",
  battleRoyaleType: "סוג משחק",
  teamMatch: "משחק קבוצתי",
  customMode: "מצב מותאם",
  solo: "יחיד",
  duo: "זוג",
  squad: "חוליה",
  team: "קבוצה",
  entryFee: "דמי כניסה",
  totalPrizePool: "סך כל הפרסים",
  roomPassword: "סיסמת חדר",
  optional: "אופציונלי",
  estimatedPrizePool: "פרס משוער",
  totalEntryFees: "סך כל דמי הכניסה",
  commission: "עמלה",
  yourEntryFee: "דמי הכניסה שלך",
  yourTotalCost: "העלות הכוללת שלך",
  entryFeeForPlayers: "דמי כניסה לשחקנים",
  insufficientPoints: "אין מספיק נקודות!",
  createTournamentBtn: "יצירת טורניר",
  createRegularTournament: "יצירת טורניר",
  createGiveawayTournament: "יצירת טורניר חינמי",
  createQuickSolo: "צור Quick Solo",
  creating: "יוצר...",
  minimize: "מזער",
  expandChat: "הרחב צ'אט",
  minimizeChat: "מזער צ'אט",
  closeChat: "סגור צ'אט",
  prizePoolForWinners: "מאגר פרסים למנצחים",
  howItWorks: "איך זה עובד",
  howItWorksQuickSolo: "משחק 1v1 מהיר על Shipment. הראשון ל{kills} הריגות או הניקוד הגבוה ביותר ב{time} מנצח!",
  howItWorksGiveaway: "אתה משלם {cost} נקודות ({prize} פרס + {commission} עמלה). שחקנים מצטרפים בחינם. המנצח(ים) מקבל(ים) בדיוק {prizePool} נקודות.",
  howItWorksRegular: "סך כל דמי הכניסה: {totalEntry} נק'. לאחר {commissionRate}% עמלה, מאגר הפרסים הוא {prizePool} נק'.",
  locked: "נעול",
  
  // ========== Quick Solo ספציפי ==========
  quickSolo: "⚡ Quick Solo (1v1)",
  quickSoloTournament: "טורניר Quick Solo",
  killLimit: "מגבלת הריגות",
  timeLimit: "מגבלת זמן",
  timeLimitSeconds: "מגבלת זמן (שניות)",
  weaponRestrictions: "הגבלות נשק (אופציונלי)",
  selectAllowedWeapons: "בחר סוגי נשק מותרים (השאר ריק לכל הנשקים)",
  selectedWeapons: "סוגי נשק נבחרים",
  allWeaponsAllowed: "כל הנשקים מותרים - לא מיושמות הגבלות",
  weaponRestrictionsWarning: "⚠️ שימוש בנשקים מוגבלים יגרום לפסילה מיידית!",
  allowedWeaponsOnly: "רק הנשקים האלה מותרים:",
  quickSoloInfo: "Quick Solo: משחקי 1v1 מהירים על Shipment בלבד. מושלם לקרבות נקודות מהירים!",
  
  // ========== סוגי נשקים ==========
  boltActionSniper: "צלף(Sniper/Marksman)",
  shotgun: "שאטגאן(Shotgun)",
  assault: "רובה סער(Assault)",
  smg: "תת-מקלע(SMG)",
  
  // ========== סטטוסי טורניר ==========
  lobby: "לובי",
  wait: "המתנה",
  activeStatus: "מחובר",
  finish: "סיום",
  deploying: "פורס",
  standbyStatus: "המתנה",
  completed: "הושלם",
  cancelled: "בוטל",
  autoCanceled: "בוטל אוטומטית",
  
  // ========== פעולות טורניר ==========
  join: "הצטרף",
  abort: "בטל",
  copy: "העתק",
  deploy: "פרוס",

  // ========== מודל הצטרפות לקבוצת BR ==========
  selectTeamPreference: "בחר העדפת קבוצה",
  selectTeam: "בחר את הקבוצה שלך",
  preference: "העדפה",
  soloTournament: "טורניר סולו",
  soloTournamentDesc: "טורניר זה דורש שכל השחקנים ישחקו לבד. אין שותפים מותרים.",
  randomTournament: "טורניר קבוצה פתוחה",
  randomTournamentDesc: "כל שחקן יכול להצטרף ולהתחבר עם אחרים. בחר את העדפת הקבוצה שלך למטה.",
  squadTournament: "טורניר צוות",
  squadTournamentDesc: "היוצר הגדיר חברי צוות. אתה יכול ליצור צוות משלך או להצטרף כאקראי.",
  teamTournament: "טורניר קבוצתי",
  creatorSquadmates: "חברי הצוות של היוצר:",
  duoTeamInfo: "בחר כיצד תרצה לשחק בטורניר דואו זה",
  squadTeamInfo: "בחר כיצד תרצה לשחק בטורניר צוות זה",
  yourTeamPreference: "העדפת הקבוצה שלך",
  soloTeam: "👤 סולו - בלי שותפים",
  soloLockedReason: "יוצר הטורניר הגדיר מצב סולו - כל השחקנים חייבים לשחק לבד.",
  randomTeam: "🎲 אקראי - כל שחקן יכול להצטרף",
  squadTeam: "👥 צוות - בחר שותפים ספציפיים",
  selectSquadmates: "בחר שותפים לצוות",
  randomPlayer: "🎲 שחקן אקראי",
  playerName: "שם שחקן",
  specific: "שחקן ספציפי",
  squadHelpText: "החלף בין שם שחקן ספציפי, שחקן אקראי או משבצת ריקה",
  soloInfo: "תשחק לבד. אף אחד לא יכול להצטרף לקבוצה שלך.",
  randomInfo: "כל שחקן זמין יכול להצטרף לקבוצה שלך.",
  selectTeamToJoin: "בחר לאיזו קבוצה להצטרף. קבוצות שמסומנות כלא זמינות יש להן הגבלות.",
  randomPreference: "העדפת שותף אקראי",
  squadPreference: "העדפת צוות",
  noAvailableTeams: "אין קבוצות זמינות להצטרפות. כל הקבוצות מלאות או יש להן הגבלות.",
  soloPlayerTeam: "שחקן סולו",
  squadOnly: "צוות בלבד",
  available: "זמין",
  spot: "מקום",
  spots: "מקומות",
  back: "חזור",

  // ========== בחירת צוות MP ==========
  captainSettings: "הגדרות קפטן הצוות",
  captainSettingsInfo: "כקפטן הצוות, בחר מי יכול להצטרף לצוות שלך",
  teamJoinMode: "מצב הצטרפות לצוות",
  randomTeammates: "אקראי - כל אחד יכול להצטרף",
  specificTeammates: "ספציפי - בחר שותפים",
  selectTeammates: "בחר שותפים (לפי שם במשחק)",
  slot: "משבצת",
  clickToEmpty: "לחץ להשאיר ריק",
  clickForRandom: "לחץ לאקראי",
  setRandom: "הגדר אקראי",
  enterInGameName: "הזן שם במשחק",
  anyPlayerCanJoin: "כל שחקן יכול להצטרף למשבצת זו",
  teammatesNote: "השאר משבצות ריקות כדי למנוע מאחרים להצטרף לצוות שלך",
  randomTeamInfo: "כל שחקן יוכל להצטרף לצוות שלך",
  youWillBeCaptain: "תהיה קפטן הצוות",
  youAreInvited: "הוזמנת לצוות זה",
  joiningViaRandomSlot: "מצטרף דרך משבצת אקראית",
  teamNotAccepting: "צוות זה לא מקבל שחקנים",
  notOnInviteList: "אתה לא ברשימת ההזמנות של צוות זה",
  invitedPlayers: "שחקנים מוזמנים:",
  createTeam: "צור צוות",
  mpTeamSelectInfo: "בחר לאיזה צוות להצטרף למשחק זה",
  teamRestriction: "הגבלת צוות",
  teamSelectionHeading: "בחירת צוות",
  specificTeam: "צוות ספציפי",

  // ========== פרטי טורניר ==========
  giveaway: "חינמי",
  highStakes: "סיכון גבוה",
  veryHighStakes: "סיכון גבוה מאוד",
  legendaryStakes: "סיכון אגדי",
  passwordProtected: "🔒מוגן",
  roomId: "🎮 חדר",
  matchLive: "משחק חי",
  tournamentId: "מזהה טורניר",
  copyTournamentId: "העתק מזהה טורניר",
  
  // ========== מבצעי טורניר ==========
  tournamentOps: "מבצעי טורניר",
  intelUpdated: "מודיעין עודכן!",
  noActiveLobies: "אין לובי פעיל",
  deployFirstTournament: "פרוס את הטורניר הראשון!",
  noPendingDeployments: "אין פריסות ממתינות",
  fullLobbiesAppear: "לובי מלא יופיע כאן (ביטול אוטומטי לאחר 30 דק')",
  noActiveOperations: "אין מבצעים פעילים",
  deployedTournamentsAppear: "טורנירים שנפרסו יופיעו כאן",
  noCompletedMissions: "אין משימות שהושלמו",
  finishedCancelledAppear: "טורנירים שהושלמו ובוטלו יופיעו כאן",
  noData: "אין נתונים",
  nothingToShow: "אין מה להציג",
  refresh: "רענן",
  
  // ========== מערכת צ'אט ==========
  chat: "צ'אט",
  searchPlayers: "חיפוש שחקנים...",
  noPlayersOnline: "אין שחקנים מחוברים",
  noPlayersMatch: "אין שחקנים שמתאימים לחיפוש",
  sendMessage: "שלח",
  messageUser: "הודעה",
  typing: "כותב...",
  connected: "מחובר לשרת!",
  hasUnread: "יש הודעות לא נקראו",
  newMessage: "הודעה חדשה",
  from: "מאת",
  in: "ב",
  
  // ========== נקודות ופרופיל ==========
  estimatedValue: "ערך משוער",
  buyPoints: "קנה נקודות",
  withdraw: "משוך",
  minimumWithdrawal: "מינימום משיכה הוא 1000 נקודות (1.50$)",
  profileManagement: "ניהול פרופיל",
  editProfile: "ערוך פרופיל",
  changePassword: "שנה סיסמה",
  updateProfile: "עדכן פרופיל",
  
  // ========== משיכות ==========
  requestWithdrawal: "בקשת משיכה",
  pointsToWithdraw: "נקודות למשיכה",
  paypalEmail: "אימייל PayPal",
  youllReceive: "תקבל",
  platformFee: "עמלת פלטפורמה",
  withdrawalInfo: "מידע משיכה",
  minimum: "מינימום",
  submitRequest: "הגש בקשה",
  withdrawalMinimum: "מינימום: 1000 נקודות ($9.50)",
  withdrawalFee: "עמלת פלטפורמה: 5%",
  withdrawalProcessing: "זמן עיבוד: 24-96 שעות",
  feePercent: "עמלה 5%",
  info: "מידע",
  submitting: "שולח...",
  submitting: "מגיש...",
  leaveEmptyToUse: "השאר ריק לשימוש באימייל החשבון שלך",
  withdrawalHistory: "היסטוריית משיכות",
  noWithdrawalRequests: "אין עדיין בקשות משיכה.",
  note: "הערה",
  
  // ========== ניהול פרופיל ==========
  currentPassword: "סיסמה נוכחית",
  newPassword: "סיסמה חדשה",
  confirmNewPassword: "אשר סיסמה חדשה",
  enterCurrentPassword: "הכנס את הסיסמה הנוכחית שלך",
  enterNewPassword: "הכנס סיסמה חדשה (מינימום 6 תווים)",
  confirmYourNewPassword: "אשר את הסיסמה החדשה שלך",
  passwordsMatch: "✓ הסיסמאות תואמות",
  passwordsDoNotMatch: "✗ הסיסמאות לא תואמות",
  securityTips: "טיפי אבטחה",
  useAtLeast8Characters: "השתמש לפחות ב-8 תווים",
  includeUppercaseLowercase: "כלול אותיות גדולות וקטנות",
  addNumbersSpecialChars: "הוסף מספרים ותווים מיוחדים",
  dontUsePersonalInfo: "אל תשתמש במידע אישי",
  changing: "משנה...",
  makesSureThisMatches: "⚠️ ודא שזה תואם את השם הנכון שלך במשחק CoD Mobile!",
  passwordStrength: "חוזק סיסמה",
  weak: "חלש",
  medium: "בינוני",
  strong: "חזק",
  useUppercaseLowercase: "השתמש באותיות גדולות, קטנות, מספרים וסמלים לסיסמה חזקה יותר",
  testCurrentPassword: "בדוק סיסמה נוכחית",
  
  // ========== היסטוריית משחקים ==========
  yourMatchHistory: "היסטוריית המשחקים שלך",
  noCompletedMatches: "אין עדיין משחקים שהושלמו.",
  joinTournamentsHistory: "הצטרף לטורנירים כדי לבנות היסטוריית משחקים!",
  entryFeeLabel: "כניסה",
  prizeLabel: "פרס",
  dateLabel: "תאריך",
  match: "משחק",
  mode: "מצב",
  date: "תאריך",
  pts: "נק'",
  split: "חולק",
  ways: "דרכים",
  youLabel: "אתה",
  loadingMatchHistory: "טוען היסטוריית משחקים...",
  
  // ========== מערכת תמיכה ==========
  supportInbox: "תיבת תמיכה",
  newReport: "דוח חדש",
  submitNewSupportReport: "הגש דוח תמיכה חדש",
  subject: "נושא",
  description: "תיאור",
  submitReport: "הגש דוח",
  noCasesYet: "אין עדיין פניות תמיכה",
  createNewReport: "צור דוח חדש אם אתה זקוק לסיוע עם טורנירים, תשלומים או בעיות חשבון.",
  submitFirstReport: "הגש את הדוח הראשון שלך",
  open: "פתוח",
  closed: "סגור",
  beforeSubmitting: "לפני הגשה:",
  beAsDetailed: "• היה מפורט ככל האפשר בתיאור שלך",
  includeRelevantUsernames: "• כלול שמות משתמש או מזהי טורניר רלוונטיים",
  supportTeamWillReview: "• צוות התמיכה שלנו יבדוק ויגיב תוך 24 שעות",
  minimumCharactersRequired: "נדרשים לפחות 5 תווים",
  minimum10CharactersRequired: "נדרשים לפחות 10 תווים",
  submissionProcess: "תהליך הגשה:",
  reportWillBeSubmitted: "הדוח שלך יוגש כסגור בתחילה ויבדק על ידי צוות התמיכה שלנו. לאחר הבדיקה, הם עשויים לפתוח אותו מחדש כדי לאפשר תקשורת נוספת במידת הצורך.",
  typeYourMessage: "הקלד את ההודעה שלך...",
  sendingMessage: "שולח...",
  send: "שלח",
  pressEnterShift: "לחץ Enter + Shift לשורה חדשה",
  caseNumber: "תיק",
  updated: "עודכן",
  messages: "הודעות",
  clickToView: "לחץ לצפייה בשיחה",
  thisCaseIsClosed: "התיק הזה סגור. אינך יכול להגיב לתיקים סגורים.",
  activeMatchDetails: "פרטי משחק פעיל",
  matchSettings: "🏆 הגדרות משחק",
  teamMembers: "👥 חברי צוות",
  type: "סוג",
  
  // ========== תרגומי פאנל תמיכה מנהל ==========
  supportInboxManagement: "ניהול תיבת תמיכה",
  createCase: "צור תיק",
  totalCases: "סך כל התיקים",
  openCases: "תיקים פתוחים",
  closedCases: "תיקים סגורים",
  allStatus: "כל הסטטוסים",
  allAssignments: "כל ההקצאות",
  unassigned: "לא מוקצה",
  assignedToMe: "מוקצה לי",
  loadingCases: "טוען תיקים...",
  noCasesFound: "לא נמצאו תיקים",
  adjustFiltersOrCreateCase: "התאם מסננים או צור תיק חדש למשתמש",
  
  // תרגומי ליבה חסרים
  unknown: "לא ידוע",
  mins: "ד",
  hrs: "ש", 
  daysShort: "י",
  ago: "לפני",
  warning: "אזהרה",
  view: "צפה",
  viewCase: "צפה",
  created: "נוצר",
  createNewCaseForUser: "צור תיק חדש למשתמש",
  selectUser: "בחר משתמש",
  searchUsersUsername: "חפש משתמשים לפי שם משתמש, אימייל או שם במשחק...",
  selected: "נבחר:",
  initialMessage: "הודעה ראשונית",
  caseSubject: "נושא התיק...",
  initialMessageToUser: "הודעה ראשונית למשתמש...",
  createCaseBtn: "צור תיק",
  closeCase: "סגור תיק",
  openCase: "פתח תיק",
  assignToMe: "הקצה לי",
  unassignCase: "בטל הקצאה",
  deleteCase: "מחק תיק",
  assignedTo: "מוקצה ל:",
  systemMessage: "מערכת",
  typeYourResponse: "הקלד את התגובה שלך...",
  deleteCaseModal: "מחק תיק",
  deleteCaseWarning: "אזהרה:",
  deleteCaseText: "פעולה זו לא ניתנת לביטול. התיק וכל ההודעות שלו יימחקו לצמיתות.",
  deleting: "מוחק...",
  youAreCurrentlyViewing: "📝 אתה צופה כעת בתיק הזה",
  youAreViewingCasesList: "📋 אתה צופה ברשימת התיקים",
  afterDeletionReturn: "לאחר המחיקה, תחזור לרשימת התיקים",
  listWillRefresh: "הרשימה תתרענן לאחר המחיקה",
  caseLabel: "תיק:",
  userLabel: "משתמש:",
  messagesLabel: "הודעות:",
  newReportFrom: "דוח חדש מ{user}: {subject}",
  newMessageInCase: "הודעה חדשה בתיק {caseNumber}",
  caseAssignedToYou: "תיק {caseNumber} הוקצה לך",
  pleaseFillAllFields: "אנא מלא את כל השדות",
  caseCreatedSuccessfully: "התיק נוצר בהצלחה",
  failedToCreateCase: "נכשל ביצירת התיק",
  pleaseEnterMessage: "אנא הכנס הודעה",
  failedToSendMessage: "נכשל בשליחת ההודעה",
  caseStatusSuccessfully: "התיק {status} בהצלחה",
  failedToUpdateCaseStatus: "נכשל בעדכון סטטוס התיק",
  caseAssignedSuccessfully: "התיק הוקצה בהצלחה",
  caseUnassignedSuccessfully: "הקצאת התיק בוטלה בהצלחה",
  failedToAssignCase: "נכשל בהקצאת התיק",
  caseDeletedSuccessfully: "התיק נמחק בהצלחה",
  failedToDeleteCase: "נכשל במחיקת התיק",
  noCaseSelectedForDeletion: "לא נבחר תיק למחיקה",
  noCaseSelected: "לא נבחר תיק",
  reasonForClosing: "סיבה לסגירת התיק הזה:",
  reasonForOpening: "סיבה לפתיחת התיק הזה:",
  closing: "סוגר",
  opening: "פותח",
  assignment: "הקצאה",
  status: "סטטוס",
  user: "משתמש",
  createdLabel: "נוצר",
  updatedLabel: "עודכן",
  emptyStateTitle: "לא נמצאו תיקים",
  emptyStateText: "התאם מסננים או צור תיק חדש למשתמש",
  
  // ========== הודעות שגיאה תמיכה ==========
  failedToLoadInbox: "נכשל בטעינת תיבת התמיכה",
  failedToLoadCase: "נכשל בטעינת התיק",
  pleaseFillBothFields: "אנא מלא גם נושא וגם תיאור",
  subjectMinLength: "הנושא חייב להכיל לפחות 5 תווים",
  descriptionMinLength: "התיאור חייב להכיל לפחות 10 תווים",
  reportSubmittedSuccessfully: "הדוח הוגש בהצלחה",
  failedToSubmitReport: "נכשל בהגשת הדוח",
  messageTooLong: "ההודעה ארוכה מדי (מקסימום 1000 תווים)",
  briefDescriptionPlaceholder: "תיאור קצר של הבעיה שלך...",
  detailedDescriptionPlaceholder: "אנא ספק מידע מפורט על הבעיה שלך, כולל שמות משתמש רלוונטיים, מזהי טורניר או צעדים לשחזור הבעיה...",
  hasBeenLabel: "הוא",
  reopened: "נפתח מחדש",
  yourCase: "התיק שלך",
  hasBeenDeleted: "נמחק על ידי",
  
  // ========== מערכת תשלומים ==========
  buyTournamentPoints: "קנה נקודות טורניר",
  chooseYourPerfectPackage: "בחר את החבילה המושלמת שלך והתחל להתחרות!",
  selectYourPackage: "בחר את החבילה שלך",
  chooseTheAmountOfPoints: "בחר את כמות הנקודות שמתאימה לצרכי המשחק שלך",
  instantDelivery: "משלוח מיידי",
  securePayment: "תשלום מאובטח",
  noExpiration: "ללא תפוגה",
  securePaymentInfo: "מידע תשלום מאובטח",
  processingPayment: "מעבד תשלום...",
  yourPaymentProcessedSecurely: "התשלום שלך מעובד בבטחה על ידי PayPal",
  pointsAddedInstantly: "נקודות מתווספות מיד לחשבון שלך",
  allTransactionsEncrypted: "כל העסקאות מוצפנות ומאובטחות",
  noHiddenFeesOrCharges: "אין עמלות נסתרות או חיובים",
  pointsPerDollar: "נקודות לדולר",
  
  // ========== תיאורי חבילות תשלום ==========
  perfectForTryingOut: "מושלם לניסיון",
  bestValueForBeginners: "הערך הטוב ביותר למתחילים",
  seriousPlayersChoice: "בחירת שחקנים רציניים",
  tournamentReady: "מוכן לטורניר",
  competitiveEdge: "יתרון תחרותי",
  proTournamentBundle: "חבילת טורניר מקצועית",
  maximumValuePack: "חבילת ערך מקסימלית",
  
  // ========== תגי חבילות ==========
  starter: "מתחיל",
  basic: "בסיסי",
  mostPopular: "הכי פופולרי",
  greatValue: "ערך מעולה",
  powerPack: "חבילת כוח",
  ultimate: "אולטימט",
  megaPack: "חבילת מגה",
  
  // ========== הוראות רכישה ==========
  howToPurchase: "איך לרכוש",
  selectPackage: "בחר חבילה",
  chooseYourPreferredPackage: "בחר את חבילת הנקודות המועדפת עליך למעלה",
  clickPayPal: "לחץ PayPal",
  proceedWithSecureCheckout: "המשך עם תשלום מאובטח דרך PayPal",
  completePayment: "השלם תשלום",
  finishTransactionViaPayPal: "סיים עסקה דרך PayPal",
  pointsAddedImmediatelyToAccount: "נקודות מתווספות מיד לחשבון",
  
  // ========== מצבי טורניר ==========
  snipersOnly: "צלפים בלבד",
  rifleOnly: "רובים בלבד",
  knifeOnly: "קרב מגע בלבד",
  executionOnly: "הוצאה להורג בלבד",
  grenadesOnly: "חומרי נפץ בלבד",
  snipers: "צלפים",
  rifles: "רובים",
  melee: "קרב מגע",
  execution: "הוצאה להורג",
  explosives: "חומרי נפץ",
  custom: "מותאם",
  ffa: "כולם נגד כולם",
  
  // ========== מצבי משחק ==========
  teamDeathmatch: "⚔️ Team Deathmatch",
  domination: "🏁 Domination",
  searchAndDestroy: "💣 Search & Destroy",
  hardpoint: "📍 Hardpoint",
  killConfirmed: "🏷️ Kill Confirmed",
  captureTheFlag: "🚩 Capture the Flag",
  frontline: "⚡ Frontline",
  freeForAll: "🎯 Free for All",
  gunGame: "🔫 Gun Game",
  sticksAndStones: "Sticks & Stones",
  oneShotOneKill: "🎯 One Shot One Kill",
  cranked: "⚡ Cranked",
  rapidFire: "💨 Rapid Fire",
  attackOfTheUndead: "🧟 Attack of the Undead",
  
  // ========== תוויות כלליות ==========
  tournament: "טורניר",
  random: "אקראי",
  
  // ========== מפות ==========
  randomMap: "🎲 מפה אקראית",
  
  // ========== מודאל סיסמה ==========
  passwordProtectedTournament: "🔒 טורניר מוגן בסיסמה 🔒",
  tournamentPasswordProtected: "טורניר זה מוגן בסיסמה. אתה צריך את הסיסמה הנכונה כדי להצטרף.",
  enterPassword: "הכנס סיסמה",
  joinTournament: "הצטרף לטורניר",
  joining: "מצטרף...",
  
  // ========== מודאל חסימה ==========
  accountBanned: "🚫 חשבון חסום 🚫",
  accountBannedDesc: "החשבון שלך נחסם ולא יכול להתחבר.",
  bannedBy: "נחסם על ידי",
  contactSupport: "פנה לתמיכה אם אתה חושב שזו שגיאה.",
  understood: "הבנתי",
  
  // ========== וידוא טפסים ==========
  fieldRequired: "שדה זה נדרש",
  invalidEmail: "אנא הכנס כתובת אימייל תקינה",
  passwordTooShort: "הסיסמה חייבת להכיל לפחות 6 תווים",
  passwordsDoNotMatchSimple: "הסיסמאות לא תואמות",
  usernameMinLength: "שם המשתמש חייב להכיל לפחות 3 תווים",
  usernameMaxLength: "שם המשתמש חייב להכיל פחות מ-20 תווים",
  invalidCharacters: "מכיל תווים לא חוקיים",
  fieldTooLong: "השדה ארוך מדי",
  fieldTooShort: "השדה קצר מדי",
  numberRequired: "אנא הכנס מספר תקין",
  numberTooLow: "המספר נמוך מדי",
  numberTooHigh: "המספר גבוה מדי",
  
  // ========== שגיאות והודעות כלליות ==========
  error: "שגיאה",
  success: "הצלחה",
  info: "מידע",
  failed: "נכשל",
  retry: "נסה שוב",
  confirm: "אשר",
  
  // ========== פעולות כלליות ==========
  save: "שמור",
  delete: "מחק",
  update: "עדכן",
  submit: "הגש",
  reject: "דחה",
  
  // ========== תרגומי ניהול חסרים ==========
  banUser: "חסום משתמש",
  unbanUser: "בטל חסימת משתמש",
  removeApprover: "הסר מאשר",
  failedToApproveMatch: "נכשל באישור משחק",
  failedToCompleteMatch: "נכשל בהשלמת משחק",
  startsIn: "מתחיל בעוד",
  
  // ========== זמן ותאריכים ==========
  now: "עכשיו",
  today: "היום",
  yesterday: "אתמול",
  timeUntilAutoCancel: "דק' עד ביטול אוטומטי",
  timeRemaining: "דק' נותרו",
  hourAgo: "לפני שעה",
  minutesAgo: "לפני דקות",
  hoursAgo: "לפני שעות",
  daysAgo: "לפני ימים",
  justNow: "זה עתה",
  
  // ========== התראות ==========
  tournamentCreated: "טורניר נוצר בהצלחה!",
  joinedTournament: "הצטרפת לטורניר בהצלחה!",
  leftTournament: "עזבת את הטורניר בהצלחה!",
  profileUpdated: "הפרופיל עודכן בהצלחה!",
  passwordChanged: "הסיסמה שונתה בהצלחה!",
  connectionRestored: "חיבור לשרת שוחזר",
  reconnecting: "מתחבר מחדש לשרת...",
  tournamentApproved: "טורניר אושר על ידי",
  tournamentCompleted: "טורניר הושלם על ידי",
  tournamentCancelled: "טורניר בוטל על ידי",
  tournamentAutoCancelled: "טורניר בוטל אוטומטית: {tournamentName}",
  createdGiveawayTournament: "יצר טורניר חינמי בלובי!",
  createdNewMatch: "יצר משחק חדש בלובי!",
  isNowOnline: "מחובר עכשיו!",
  commissionDistributed: "עמלה הופצה!",
  commissionUpdated: "הגדרות עמלה עודכנו!",
  
  // ========== מחרוזות נוספות ==========
  participants: "משתתפים",
  showParticipants: "הצג משתתפים",
  hideParticipants: "הסתר משתתפים",

  // ========== טורניר סוגריים ==========
  multistepTournaments: "טורנירי שלבים",
  multistepTournament: "טורניר שלבים",
  createBracketTournament: "צור טורניר שלבים",
  createBracket: "צור",
  noBracketTournaments: "אין עדיין טורנירי שלבים",
  bracketTournamentCreated: "טורניר שלבים נוצר!",
  numberOfTeams: "מספר קבוצות",
  costSummary: "סיכום עלויות",
  prizePerWinner: "פרס למנצח",
  needMore: "חסר",
  morePoints: "נקודות נוספות",
  confirmCreate: "אשר יצירת טורניר",
  viewBracket: "צפה בסוגריים",
  tournamentBracket: "סוגרי טורניר",
  joinedTeam: "הצטרפת לקבוצה בהצלחה!",
  tournamentStarted: "הטורניר התחיל!",
  confirmWinner: "להגדיר קבוצה זו כמנצחת?",
  yourTeam: "הקבוצה שלך",
  registration: "הרשמה",
  final: "גמר",
  semiFinals: "חצי גמר",
  quarterFinals: "רבע גמר",
  round: "סיבוב",
  matches: "משחקים",
  tbd: "טרם נקבע",
  clickToSelectWinner: "לחץ על קבוצה לבחירת מנצח",
  perWinner: "למנצח",
  tournamentWinners: "מנצחי הטורניר",
  full: "מלא",
  showTeams: "הצג קבוצות",
  hideTeams: "הסתר קבוצות",
  startTournament: "התחל",

  insufficientPointsDetailed: "אין מספיק נקודות! אתה צריך {needed} נקודות אבל יש לך רק {current} נקודות.",
  giveawayExplanation: "בטורנירים חינמיים, אתה משלם {prize} נקודות (פרס) + {commission} נקודות (עמלה) = {total} סה\"כ",
  disobeyingWeaponRules: "⚠️ אי ציות לחוקי הנשק יגרום לאובדן נקודות מיידי!",
  estimatedPrizePoolCalculation: "חישוב פרס משוער",
  baseCommission: "🏛️ עמלה בסיסית",
  highKillBonus: "⚡ בונוס הרגים גבוהים",
  totalCommission: "📊 סך עמלה",
  extraCommissionFromHighKills: "עמלה נוספת של {rate}% ממספר הרגים גבוה הולכת למאשר.",
  failedToLoadTournaments: "נכשל בטעינת טורנירים",
  system: "מערכת",
  
  // ========== כרטיס טורניר ספציפי ==========
  participantsCount: "{current}/{max}",
  prizeFormat: "🏆{amount}",
  entryFormat: "💰{amount}",
  killsFormat: "💀{amount}K",
  modeFormat: "⚔️{mode}",
  mapFormat: "📍{map}",
  teamFormat: "👥{count}",
  timeFormat: "⏰{time}",
  dateFormat: "📅{date}",
  
  // ========== אזהרות זמן המתנה ==========
  warningAutoCancel: "⚠️ {time}דק' עד ביטול אוטומטי",
  warningTimeRemaining: "⏰ {time}דק' נותרו",
  
  // ========== משחק פעיל ==========
  gameSettings: "הגדרות משחק",
  prizePool: "פרס",
  
  // ========== טורנירים שהסתיימו ==========
  autoCancel: "בוטל אוטומטית",
  canceled: "בוטל",
  cancelledBy: "בוטל על ידי",
  more: "עוד",
  approvedBy: "אושר על ידי",
  
  // ========== תיקוני טורניר מהיר ==========
  failedToCreateTournament: "נכשל ביצירת הטורניר",
  matchType: "סוג מתחרה",

  // ========== טורניר רב-שלבי (מפתחות חדשים בלבד) ==========
  viewAllTeams: "כל הקבוצות והמשחקים",
  allTeamsMatchups: "כל הקבוצות והמשחקים",
  teams: "קבוצות",
  activeBracketMatches: "משחקי בתים פעילים",
  configureMatch: "הגדר משחק",
  configureMatchups: "הגדר משחקים",
  startMatch: "התחל משחק",
  applications: "בקשות",
  pendingTeams: "קבוצות ממתינות",
  approvedTeams: "קבוצות מאושרות",
  pendingApplications: "בקשות ממתינות",
  noApplications: "אין בקשות ממתינות",
  noApprovedTeamsYet: "אין קבוצות מאושרות עדיין",
  pendingTeamsApproval: "קבוצות ממתינות לאישור",
  pendingTeamsInfo: "קבוצות אלו ממתינות לאישור",
  approveTeam: "אשר קבוצה",
  teamApproved: "הקבוצה אושרה!",
  teamRejected: "הקבוצה נדחתה והוסרה",
  applicationApproved: "הבקשה אושרה!",
  applicationRejected: "הבקשה נדחתה",
  errorApprovingTeam: "שגיאה באישור הקבוצה",
  errorRejectingTeam: "שגיאה בדחיית הקבוצה",
  errorApproving: "שגיאה באישור הבקשה",
  errorRejecting: "שגיאה בדחיית הבקשה",
  applyToTournament: "הגש בקשה לטורניר",
  applyToJoin: "הגש בקשה להצטרפות",
  applyToTeam: "הגש בקשה",
  applying: "מגיש בקשה...",
  applied: "הוגשה בקשה",
  teamApplied: "בקשת הקבוצה הוגשה! ממתין לאישור מנהל.",
  applicationSubmitted: "הבקשה הוגשה! ממתין לאישור מנהל.",
  applicationPending: "הבקשה שלך ל",
  isPending: "ממתינה לאישור",
  awaitingApproval: "ממתין לאישור",
  createNewTeam: "צור קבוצה חדשה",
  youAreCaptain: "אתה קפטן הקבוצה!",
  captainInfo: "כקפטן, תוכל להגדיר העדפות למי יכול להצטרף לקבוצה שלך.",
  teamPreferences: "העדפות קבוצה",
  setPreferencesFirst: "בחר קבוצה קודם",
  captain: "קפטן",
  teamName: "שם הקבוצה",
  enterTeamName: "הזן שם קבוצה...",
  teammates: "חברי קבוצה",
  teammate: "חבר קבוצה",
  teammatesHint: "הזן את שמות המשתמשים של 4 חברי הקבוצה שלך",
  teammatesUpdated: "שמות חברי הקבוצה עודכנו!",
  editTeammates: "ערוך שמות חברי קבוצה",
  editTeammateNames: "ערוך שמות חברי קבוצה",
  editNames: "ערוך שמות",
  editHint: "עדכן את שמות המשתמשים של חברי הקבוצה",
  saveChanges: "שמור שינויים",
  need4Teammates: "עליך לציין את כל 4 חברי הקבוצה",
  needMoreTeammates: "צריך עוד שמות חברי קבוצה",
  duplicateNames: "שמות חברי הקבוצה חייבים להיות ייחודיים",
  dontIncludeYourself: "אל תכלול את עצמך ברשימת חברי הקבוצה",
  errorCreatingTeam: "שגיאה ביצירת הקבוצה",
  yourAllowedSquadmates: "חברי הצוות המורשים שלך",
  noSquadmatesSet: "לא הוגדרו חברי צוות - כל אחד יכול להצטרף לקבוצה שלך",
  edit: "ערוך",
  save: "שמור",
  saving: "שומר...",
  errorUpdating: "שגיאה בעדכון חברי הקבוצה",
  joinThisTeam: "הצטרף לקבוצה",
  joinYourTeam: "הצטרף לקבוצה שלך",
  leaveTeam: "עזוב קבוצה",
  confirmLeave: "האם אתה בטוח שברצונך לעזוב?",
  errorJoining: "שגיאה בהצטרפות לקבוצה",
  errorLeaving: "שגיאה בעזיבה",
  kickPlayer: "הסר שחקן",
  kickTeam: "הרחק/פסול קבוצה",
  playerKicked: "השחקן הוסר מהקבוצה",
  teamKicked: "הקבוצה הורחקה",
  confirmKick: "להסיר שחקן זה מהקבוצה שלך?",
  enterKickReason: "הזן סיבה להרחקת/פסילת הקבוצה:",
  errorKicking: "שגיאה בהסרת השחקן",
  errorKickingTeam: "שגיאה בהרחקת הקבוצה",
  invited: "מוזמנים",
  inviteOnly: "הזמנה בלבד",
  yourNameInvited: "השם שלך חייב להיות ברשימת המוזמנים כדי להצטרף",
  waiting: "ממתין",
  waitingToJoin: "ממתין להצטרפות",
  captain: "קפטן",
  totalSlots: "סה״כ משבצות",
  alreadyJoined: "כבר הצטרפת",
  allTeamsTaken: "כל הקבוצות תפוסות",
  teamsReady: "קבוצות מוכנות",
  teamsWaitingForYou: "קבוצות מחכות לך",
  applyHint: "הגש בקשה להצטרף לקבוצה קיימת או צור משלך",
  applyHintAdmin: "צור קבוצות והגדר משחקים",
  createHintFull: "כל משבצות הקבוצות מלאות",
  enterRoomId: "הזן מזהה חדר",
  customMap: "מפה מותאמת",
  enterCustomMapName: "הזן שם מפה מותאמת",
  matchStarted: "המשחק התחיל!",
  errorStartingMatch: "שגיאה בהתחלת המשחק",
  confirmStart: "להתחיל את הטורניר? הקבוצות יינעלו.",
  errorStarting: "שגיאה בהתחלת הטורניר",
  selectWinner: "בחר מנצח",
  errorSettingWinner: "שגיאה בקביעת המנצח",
  cancelReason: "סיבה לביטול:",
  errorCancelling: "שגיאה בביטול",
  firstRoundMatchups: "משחקי סיבוב ראשון",
  matchupHint: "הגדר אילו קבוצות מתמודדות זו מול זו",
  saveMatchups: "שמור משחקים",
  selectBothTeams: "אנא בחר את שתי הקבוצות לכל המשחקים",
  duplicateTeam: "כל קבוצה יכולה להופיע רק פעם אחת",
  matchupsConfigured: "המשחקים הוגדרו בהצלחה!",
  errorConfiguringMatchups: "שגיאה בהגדרת המשחקים",
  adjustSizeTo: "התאם ל",
  confirmAdjustSize: "להתאים את גודל הסוגריים? זה יחדש את מבנה הסוגריים.",
  bracketAdjusted: "הסוגריים הותאמו",
  errorAdjustingSize: "שגיאה בהתאמת גודל הסוגריים",
  allTeamsApproved: "כל הקבוצות אושרו",
  approveAllTeams: "אשר את כל הקבוצות",
  confirmApproveAll: "לאשר את כל הקבוצות הממתינות?",
  reroll: "הגרל מחדש",
  rerollMatchup: "החלפה אקראית",
  other: "אחר",
  otherMatchup: "בחר קבוצה להחלפה",
  selectTeamToSwap: "בחר קבוצה להחלפה:",
  teamSwapped: "הקבוצה הוחלפה!",
  errorSwappingTeam: "שגיאה בהחלפת הקבוצה",
  or: "או",
  fillAllFields: "אנא מלא את כל השדות",
  required: "נדרש",
  prizeSummary: "סיכום פרסים",
  freeForAdmins: "חינם למנהלים",
  gameModePerMatch: "מצב משחק ומפה מוגדרים בנפרד לכל משחק",
  each: "כל אחד",
  starting: "מתחיל...",
  pendingApproval: "ממתין לאישור",

  // ========== VOTE TO START EARLY ==========
  voteEarlyStart: "הצבעה להתחלה מוקדמת",
  voteToStart: "הצבע להתחלה מוקדמת",
  voteToStartEarly: "הצבע להתחלת הטורניר מוקדם",
  voteRecorded: "ההצבעה נרשמה! ({current}/{total})",
  voteRemoved: "ההצבעה הוסרה",
  voteRequestSent: "בקשת הצבעה נשלחה לכל המשתתפים!",
  voteInProgress: "הצבעה בתהליך ({current}/{total})",
  vote: "הצבע",
  earlyPrize: "התחלה מוקדמת",
  votesNeeded: "הצבעות נדרשות",
  votedPlayers: "שחקנים שהצביעו",
  voteRequestSentWaiting: "בקשת הצבעה נשלחה! ממתין לשחקנים...",
  voteNote: "הטורניר יתחיל אוטומטית כאשר כל השחקנים האמיתיים יצביעו.",
  voteNoteGiveaway: "במשחקי הגרלה, היוצר חייב להתחיל ידנית לאחר שכל ההצבעות התקבלו.",

  // ========== CREATE TOURNAMENT TEAM PREFERENCE ==========
  teamPreference: "העדפת קבוצה",
  randomAnyPlayerCanJoin: "אקראי - כל שחקן יכול להצטרף לקבוצה שלך",
  specificChooseTeammates: "ספציפי - בחר את חברי הקבוצה שלך",
  emptySlotOptional: "משבצת ריקה (אופציונלי)",
  enterPlayerInGameName: "הזן שם שחקן במשחק",

  // ========== BR EDIT TEAM ==========
  editTeam: "ערוך קבוצה",
  viewTeam: "צפה בקבוצה",
  viewPlayers: "צפה בשחקנים",
  viewTeamPositions: "מיקומי קבוצות",
  editAllowedTeammates: "ערוך חברי קבוצה מורשים",
  teammatesHint: "הזן את שמות השחקנים המורשים להצטרף לקבוצה שלך. השאר ריק או הגדר כאקראי כדי לאפשר לכל אחד.",
  mpTeammatesHint: "הזן שמות שחקנים לאפשר שחקנים ספציפיים. השתמש ב-🎲 לשחקנים אקראיים. משבצות ריקות נעולות.",
  specificPreference: "מצב ספציפי - רק שחקנים בעלי שם יכולים להצטרף",
  captain: "קפטן",
  specific: "ספציפי",
  lockedSlot: "משבצת נעולה",
  lockedSlotInfo: "🔒 נעול - אף אחד לא יכול להצטרף",
  openSlot: "משבצת פתוחה",
  waitingFor: "ממתין ל",
  unlockSlot: "פתח משבצת (אפשר אקראי)",
  lockSlot: "נעל משבצת",

  // ========== KICK PLAYER MODAL ==========
  kickPlayerTitle: "הסר שחקן",
  kickPlayerConfirm: "האם אתה בטוח שברצונך להסיר שחקן זה?",
  kickFillerConfirm: "להסיר את הממלא מהטורניר?",
  removeFromTournament: "הסר מהטורניר",
  kickReason: "סיבה (אופציונלי)",

  // ========== MP TEAM SELECTION ==========
  teamSelection: "בחירת קבוצה",
  selectTeam: "בחר את הקבוצה שלך",
  mpTeamSelectInfo: "בחר לאיזו קבוצה להצטרף במשחק זה",
  youWillBeCaptain: "תהיה קפטן הקבוצה",
  youAreInvited: "אתה מוזמן לקבוצה זו",
  joiningViaRandomSlot: "מצטרף דרך משבצת אקראית",
  teamNotAccepting: "קבוצה זו לא מקבלת שחקנים",
  squadOnly: "קבוצה בלבד",
  spotsAvailable: "מקומות פנויים",
  captainSettings: "הגדרות קפטן הקבוצה",
  captainSettingsInfo: "כקפטן הקבוצה, בחר מי יכול להצטרף לקבוצה שלך",
  teamJoinMode: "מצב הצטרפות לקבוצה",
  randomTeammate: "🎲 אקראי - כל שחקן יכול להצטרף לקבוצה שלך",
  specificTeammate: "👥 ספציפי - בחר את חברי הקבוצה שלך",
  slot: "משבצת",
  clickToEmpty: "לחץ להשאיר ריק",
  clickForRandom: "לחץ לאקראי",
  random: "אקראי",
  setRandom: "הגדר אקראי",
  anyPlayerCanJoin: "כל שחקן יכול להצטרף למשבצת זו",
  teammatesNote: "השאר משבצות ריקות כדי למנוע מאחרים להצטרף לקבוצה שלך",
  joining: "מצטרף...",
  createTeam: "צור קבוצה",
  joinTeam: "הצטרף לקבוצה",
  editTeamPreferences: "ערוך העדפות קבוצה",
  viewAllTeamPositions: "צפה בכל מיקומי הקבוצות",
  emptySlot: "משבצת ריקה",
  enterPlayerInGameName: "הזן שם שחקן במשחק",
  enterNameOrSetRandom: "הזן שם או הגדר אקראי",
  enterExactInGameName: "הזן את השם המדויק של חבר הקבוצה שלך במשחק, או הגדר אקראי",
  editAllowedSquadmates: "ערוך חברי צוות מורשים",
  squadPreference: "מצב צוות - רק חברי צוות ספציפיים",
  randomPreference: "מצב אקראי - כל אחד יכול להצטרף",
  squadmatesHint: "הזן את שמות השחקנים המורשים להצטרף לקבוצה שלך. השאר ריק או הגדר אקראי כדי לאפשר לכל אחד.",
  slot: "משבצת",
  anyoneCanJoin: "כל אחד יכול להצטרף למשבצת זו",
  emptySlotInfo: "ריק - אף אחד לא יכול להשתמש במשבצת זו",
  specificPlayer: "רק שחקן זה יכול להצטרף",
  clearSlot: "נקה משבצת",
  randomPlayer: "שחקן אקראי",
  enterPlayerName: "הזן שם שחקן...",
  playerName: "שם שחקן",
  saveChanges: "שמור שינויים",
  saving: "שומר...",

  // ========== VOTE EARLY START MODAL ==========
  prizeReductionWarning: "אזהרת הפחתת פרס",
  lobbyNotFull: "הלובי לא מלא ({current}/{max} שחקנים)",
  current: "נוכחי",

  // ========== KICK PLAYER MODAL EXTRAS ==========
  kick: "הסר",
  realPlayer: "שחקן אמיתי",
  fillerPlayer: "שחקן ממלא",
  fillerBot: "בוט ממלא",
  playerWillReceiveRefund: "השחקן יקבל החזר של {amount} נקודות",
  thisActionIsPermanent: "פעולה זו היא קבועה",
  playerWillBeRemoved: "שחקן זה יוסר מהטורניר ולא יוכל להצטרף מחדש.",
  tournamentInformation: "מידע על הטורניר",
  currentPlayers: "נוכחי: {current}/{max} שחקנים",
  kickParticipant: "הסר {type}",
  player: "שחקן",
  filler: "ממלא",
  yourFiller: "הממלא שלך",
  youAddedThis: "הוספת את הממלא הזה",
  othersFiller: "הממלא של מישהו אחר",
  addedBySomeoneElse: "נוסף על ידי שחקן אחר",
  refundInformation: "מידע החזר",
  playerRefund: "השחקן יקבל החזר של {amount} נקודות",
  fillerRefund: "בעל הממלא יקבל החזר של {amount} נקודות",
  fillerRefundNote: "ההחזר מגיע למי שהוסיף את הממלא",
  permanentAction: "פעולה זו היא קבועה",
  playerKickWarning: "שחקן זה יוסר מהטורניר ולא יוכל להצטרף מחדש.",
  fillerKickWarning: "הממלא הזה יוסר מהטורניר ולא ניתן להוסיפו מחדש.",
  tournamentInfo: "מידע על הטורניר",
  currentParticipants: "נוכחי: {current}/{max} שחקנים",
  currentFillers: "ממלאים: {count}",
  kicking: "מסיר...",
  confirmKick: "הסר {type}",
  // Subscription translations
  weeklyPointDeals: "מבצעי נקודות שבועיים",
  subscriptionDescription: "קבל 50% נקודות מיידית + 50% יומי למשך 7 ימים",
  activePlan: "פעיל",
  dayProgress: "יום",
  pointsReceived: "נקודות התקבלו",
  alreadyActive: "כבר פעיל",
  selectPlan: "בחר תוכנית",
  totalPoints: "סהכ נקודות",
  instant: "מיידי",
  perDay: "/יום",
  days: "ימים",
  ptsPerDollar: "נק לכל $1",
  perWeek: "/שבוע",
  processingSubscription: "מעבד את המנוי שלך...",
  tierBasic: "בסיסי",
  tierStandard: "סטנדרט",
  tierPlus: "פלוס",
  tierPremium: "פרימיום",
  tierMax: "מקס",
  // Vendor System
  vendorPackages: "חבילות ספקים",
  vendorPackagesDescription: "רכישת חבילות מהספקים השותפים שלנו",
  currentRate: "שער נוכחי",
  selectedPackage: "חבילה נבחרת",
  purchasePackage: "רכישת חבילה",
  vendorNote: "הספק יעבד את הבקשה שלך ויספק את החבילה.",
  purchaseHistory: "היסטוריית רכישות",
  noPurchasesYet: "אין רכישות עדיין",
  awaitingVendor: "ממתין לעיבוד הספק",
  vendorRedeemed: "הספק עיבד את הבקשה שלך",
  pointsRefunded: "הנקודות הוחזרו",
  packagePurchased: "החבילה נרכשה בהצלחה!",
  purchaseFailed: "רכישת החבילה נכשלה",
  dashboard: "לוח בקרה",
  refresh: "רענון",
  pending: "ממתין",
  redeemed: "נפדה",
  confirmed: "אושר",
  cancelled: "בוטל",
  totalValue: "ערך כולל",
  all: "הכל",
  searchCoupons: "חיפוש קופונים...",
  noCouponsFound: "לא נמצאו קופונים",
  redeem: "פדיון",
  cancel: "ביטול",
  delete: "מחיקה",
  waitingAdminConfirmation: "ממתין לאישור מנהל",
  cancelCoupon: "ביטול קופון",
  cancelWarning: "פעולה זו תחזיר את כל הנקודות למשתמש. לא ניתן לבטל.",
  user: "משתמש",
  package: "חבילה",
  refundAmount: "סכום החזר",
  typeCancel: "הקלד Cancel לאישור",
  back: "חזור",
  confirmCancel: "אישור ביטול",
  couponRedeemed: "הקופון נפדה בהצלחה",
  couponCancelled: "הקופון בוטל והנקודות הוחזרו",
  couponDeleted: "הקופון נמחק",
  vendorCoupons: "קופוני ספקים",
  owed: "חוב",
  paid: "שולם",
  redeemed: "מומש",
  pts: "נק",
  upToTwoWeeks: "עד שבועיים",
  upToAWeek: "עד שבוע",
  minutesTo24Hours: "דקות עד 24 שעות",
  specialUpTo3Hours: "מיוחד עד 3 שעות",
  upTo48Hours: "עד 48 שעות",
  confirmPurchase: "אישור רכישה",
  confirmPurchaseText: "האם אתה בטוח שברצונך לרכוש חבילה זו?",
  yesPurchase: "כן, רכוש",
  confirmRedeem: "אישור מימוש",
  redeemConfirmText: "האם אתה בטוח שברצונך לסמן קופון זה כממומש?",
  yesRedeem: "כן, ממש",
  no: "לא",
  couponCode: "קוד קופון",
  awaitingConfirmation: "ממתין לאישור תשלום",
  confirmPayment: "אישור תשלום",
  confirming: "מאשר...",
  couponConfirmed: "הקופון אושר בהצלחה",
  vendorILSRate: "שער שקל לספקים",
  ilsRateDescription: "שער החליפין לתמחור חבילות ספקים (שקל לדולר)",
  ilsToUsdRate: "1 דולר = ? שקל",
  updateILSRate: "עדכון שער שקל",
  ilsRateUpdated: "שער השקל עודכן בהצלחה",
  speedos: "ספידוס",
  ryder: "ריידר",

  
  // ========== MP MULTISTEP & ADDITIONAL ==========
  mpMultistep: "מולטיפלייר רב שלבי",
  mpMultistepDesc: "טורניר מולטיפלייר מבוסס קבוצות עם התקדמות בסוגריים. 5 שחקנים לקבוצה.",
  teamsCount: "4, 8, או 16 קבוצות",
  bracketElimination: "פורמט הדחה בסוגריים",
  gameModePerMatch: "מצב משחק נקבע לכל משחק",
  soloSquadModes: "מצבי יחיד, זוגות או סקווד",
  roundsRange: "2-5 סיבובים",
  cumulativePoints: "נקודות מצטברות מהריגות + מיקום",
  pts: "נק׳",
// ========== BR MULTISTEP TOURNAMENT ==========
  brMultistep: "באטל רויאל רב שלבי",
  brMultistepDesc: "טורניר באטל רויאל עם מספר סיבובים",
  br_multistep: "באטל רויאל רב שלבי",
  createBRMultistep: "צור טורניר באטל רויאל רב שלבי",
  brMultistepCreated: "טורניר באטל רויאל רב שלבי נוצר בהצלחה",
// ========== FFA MULTISTEP TOURNAMENT ==========  ffaTournament: "טורניר FFA",  ffaMultistep: "טורניר FFA",  ffaMultistepDesc: "טורניר כל אחד נגד כולם עם לובי של עד 8 שחקנים. אדמין מאשר שחקנים ובוחר מנצחים.",  createFFAMultistep: "צור טורניר FFA",  ffaCreated: "טורניר FFA נוצר!",  ffaTournamentInfo: "טורניר כל אחד נגד כולם",  ffaInfoDesc: "שחקנים מתחרים בלובי של עד 8. המנצחים עולים לגמר. אדמין מאשר שחקנים ובוחר מנצחים באופן ידני.",  maxPlayers64: "עד 64 שחקנים",  twoRounds: "2 סיבובים: לובי + גמר",  adminApproval: "נדרש אישור אדמין",  round1: "סיבוב 1",  round1AndFinals: "סיבוב 1 + גמר",  lobbiesOf8: "לובי (מקסימום 8 שחקנים בכל אחד)",  finals: "גמר",  grandWinner: "מנצח הטורניר",  ptsAwarded: "נקודות הוענקו",  registration: "הרשמה פתוחה",  pendingApproval: "ממתין לאישור",  round1Lobby: "סיבוב 1 - לובי מוכנים",  round1InProgress: "סיבוב 1 בתהליך",  finalsLobby: "לובי גמר מוכן",  finalsInProgress: "גמר בתהליך",  waitingApproval: "ממתין לאישור אדמין...",  youAreApproved: "אתה מאושר! המתן להתחלת הטורניר.",  requestToJoin: "בקש להצטרף",  manageApprovals: "נהל אישורים",  pendingPlayers: "שחקנים ממתינים",  approvedPlayers: "שחקנים מאושרים",  noPendingPlayers: "אין שחקנים ממתינים",  noApprovedPlayers: "אין שחקנים מאושרים",  approveAll: "אשר הכל",  playerApproved: "שחקן אושר!",  allApproved: "כל השחקנים אושרו!",  playerRejected: "שחקן נדחה",  playerRemoved: "שחקן הוסר",  confirmReject: "לדחות שחקן זה?",  confirmRemove: "להסיר שחקן זה?",  createLobbiesRandom: "צור לובי (אקראי)",  confirmCreateLobbies: "ליצור לובי? שחקנים ישובצו באקראי.",  lobbiesCreated: "לובי נוצרו!",  lobbiesComplete: "לובי הושלמו",  lobby: "לובי",  startMatch: "התחל משחק",  selectWinner: "בחר מנצח",  startFinals: "התחל גמר",  selectGrandWinner: "בחר את המנצח הגדול",  winnerSelected: "מנצח נבחר!",  confirmSelectWinner: "לבחור שחקן זה כמנצח?",  roomId: "מזהה חדר",  roomUrl: "קישור לחדר",  enterRoomId: "הזן מזהה חדר",  enterRoomUrl: "הזן קישור לחדר",  roomInfoNote: "פרטי החדר יישלחו רק לשחקנים במשחק זה.",  yourRoom: "החדר שלך",  yourFinalsRoom: "חדר הגמר שלך",  joinRoom: "הצטרף לחדר",  cancelTournament: "בטל",  deleteTournament: "מחק",  confirmCancel: "לבטל טורניר זה? הפרס יוחזר.",  confirmDelete: "למחוק לצמיתות את הטורניר? פעולה זו בלתי הפיכה!",  confirmDeleteAgain: "אתה בטוח? הטורניר יימחק לחלוטין.",  tournamentDeleted: "טורניר נמחק",  tournamentCancelled: "טורניר בוטל",  viewHistory: "צפה בהיסטוריה",  noHistory: "אין היסטוריה עדיין",  playerMoved: "שחקן הועבר!",  moveFailed: "העברת שחקן נכשלה",  waitingToStart: "ממתין להתחלה",  matchInProgress: "משחק בתהליך",  finalsComplete: "גמר הושלם",  fromLobby: "מלובי",  joinInfo: "בקשתך תיבדק על ידי אדמין.",  submitRequest: "שלח בקשה",  submitting: "שולח...",  starting: "מתחיל...",
  solo: "יחיד",
  soloDesc: "שחקנים מתחרים בנפרד",
  duo: "זוגות",
  duoDesc: "קבוצות של 2 שחקנים",
  squad: "סקווד",
  squadDesc: "קבוצות של 4 שחקנים",
  controlMode: "מצב שליטה",
  control: "שליטה",
  manual: "ידני",
  manualDesc: "מנהל מנהל חדרים ידנית",
  bot: "בוט",
  botDesc: "בוט יוצר ומנהל חדרים אוטומטית",
  botIdle: "בוט ממתין",
  botCreatingRoom: "יוצר חדר...",
  botRoomReady: "חדר מוכן",
  botWaitingPlayers: "ממתין לשחקנים",
  botMatchActive: "משחק בתהליך",
  botExtractingResults: "מחלץ תוצאות",
  botRoundComplete: "סיבוב הושלם",
  botError: "שגיאת בוט",
  botReconnected: "בוט התחבר מחדש",
  numberOfRounds: "מספר סיבובים",
  rounds: "סיבובים",
  scheduledStart: "מועד התחלה מתוכנן",
  scheduledStartHint: "מתי הטורניר מתוכנן להתחיל",
  pointsConfiguration: "הגדרות נקודות",
  pointsPerKill: "נקודות להריגה",
  perKill: "להריגה",
  placementPoints: "נקודות מיקום",
  placementHint: "נקודות לפי מיקום סופי",
  addPlacement: "הוסף מיקום",
  place: "מקום",
  pointsDistribution: "חלוקת נקודות",
  teams: "קבוצות",
  allTeams: "כל הקבוצות",
  noTeamsYet: "אין קבוצות עדיין",
  createNewTeam: "צור קבוצה חדשה",
  teamName: "שם קבוצה",
  enterTeamName: "הכנס שם קבוצה",
  teammates: "חברי קבוצה",
  teammate: "חבר קבוצה",
  enterTeammateNames: "הכנס שמות חברי קבוצה",
  enterAllTeammates: "הכנס את כל שמות חברי הקבוצה",
  teamSize: "גודל קבוצה",
  teamWillHave: "הקבוצה תכלול",
  youPlus: "אתה +",
  editTeam: "ערוך קבוצה",
  editTeammatesHint: "ערוך את חברי הקבוצה",
  editTeamNote: "ניתן לערוך קבוצה לפני תחילת הטורניר",
  teamUpdated: "הקבוצה עודכנה בהצלחה",
  viewTeams: "צפה בקבוצות",
  yourTeam: "הקבוצה שלך",
  leader: "מוביל",
  joinThisTeam: "הצטרף לקבוצה זו",
  joinMyTeam: "הצטרף לקבוצה שלי",
  joinMyTeamSelect: "בחר קבוצה להצטרפות",
  joinWithTeam: "הצטרף עם קבוצה",
  selectYourTeam: "בחר את הקבוצה שלך",
  joinedTeam: "הצטרפת לקבוצה בהצלחה",
  leaveTeam: "עזוב קבוצה",
  duplicateTeammate: "שם חבר קבוצה כפול",
  multipleTeamsInvited: "ניתן להזמין מספר קבוצות",
  pendingSlots: "מקומות פנויים",
  manageRounds: "נהל סיבובים",
  matchSettings: "הגדרות משחק",
  editSettings: "ערוך הגדרות",
  saveSettings: "שמור הגדרות",
  saveChanges: "שמור שינויים",
  settingsSaved: "הגדרות נשמרו בהצלחה",
  confirmCreate: "ליצור טורניר?",
  confirmStart: "להתחיל טורניר?",
  confirmCancel: "לבטל טורניר?",
  confirmSwitchToManual: "לעבור לשליטה ידנית?",
  switchedToManual: "עבר לשליטה ידנית",
  roundStarting: "סיבוב מתחיל",
  lobby: "לובי",
  inProgress: "בתהליך",
  completed: "הושלם",
  cancelled: "בוטל",
  startsAt: "מתחיל ב",
  joining: "מצטרף...",
  creating: "יוצר...",
  saving: "שומר...",
  joinTournament: "הצטרף לטורניר",
  joinedTournament: "הצטרפת לטורניר",
  leftTournament: "עזבת את הטורניר",
  tournamentStarted: "הטורניר התחיל",
  tournamentCancelled: "הטורניר בוטל",
  tournamentSummary: "סיכום טורניר",
  errorCreating: "שגיאה ביצירת טורניר",
  failedToJoin: "ההצטרפות נכשלה",
  failedToJoinTeam: "ההצטרפות לקבוצה נכשלה",
  failedToLeave: "העזיבה נכשלה",
  failedToStart: "ההתחלה נכשלה",
  failedToStartRound: "התחלת הסיבוב נכשלה",
  failedToCancel: "הביטול נכשל",
  failedToSaveSettings: "שמירת ההגדרות נכשלה",
  failedToUpdateTeam: "עדכון הקבוצה נכשל",
  switchFailed: "המעבר נכשל",
  commandFailed: "הפקודה נכשלה",
  reconnectFailed: "ההתחברות מחדש נכשלה",
  commandSent: "הפקודה נשלחה",
  maxPlayers: "מקסימום שחקנים",
  leaveEmptyForPublic: "השאר ריק לציבורי",
  optional: "אופציונלי",
  required: "חובה",
  freeForAdmins: "חינם למנהלים",
  minPlayersRequired: "נדרש מינימום שחקנים",
  playersNotDivisible: "מספר השחקנים לא מתחלק בגודל הקבוצה",
  selectTournamentType: "בחר סוג טורניר",

};

// Language configuration
export const languageConfig = {
  en: {
    name: 'English',
    flag: '🇺🇸',
    dir: 'ltr',
    nativeName: 'English'
  },
  he: {
    name: 'Hebrew',
    flag: '🇮🇱', 
    dir: 'rtl',
    nativeName: 'עברית'
  },

  // Withdraw Options
  chooseWithdrawMethod: 'בחר שיטת משיכה',
  selectHowToWithdraw: 'בחר כיצד למשוך את הנקודות שלך',
  withdrawPaypal: 'משיכה דרך PayPal',
  withdrawPaypalDesc: 'העברה ישירה לחשבון PayPal - מינימום 1,000 נק׳',
  speedosDesc: 'חבילות CP ומשחקים',
  ryderDesc: 'חבילות CP ומשחקים',
  backToOptions: 'חזרה לאפשרויות',
  packages: 'חבילות',
  contactVendor: 'צור קשר',
  contactOnTelegram: 'צור קשר בטלגרם',
  afterPurchaseContact: 'לאחר הרכישה, צור קשר עם הספק בטלגרם:',
  ils: 'ש"ח'
};

// Main translations object for backward compatibility
export const translations = {
  he: hebrewTranslations
};

// Enhanced translation utility functions
export const getTranslation = (key, language = 'he', fallback = null) => {
  const translation = hebrewTranslations[key];
  if (translation) return translation;
  
  // Return custom fallback or the key itself
  return fallback || key;











};

export const isRTL = (language) => {
  return languageConfig[language]?.dir === 'rtl';
};

// Enhanced RTL initialization utility
export const initializeRTL = (language) => {
  const isRtl = isRTL(language);
  const htmlElement = document.documentElement;
  
  // Set direction and language attributes
  htmlElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
  htmlElement.setAttribute('lang', language);
  
  // Apply or remove RTL class
  if (isRtl) {
    htmlElement.classList.add('rtl-layout');
  } else {
    htmlElement.classList.remove('rtl-layout');
  }
  
  // Save language preference
  localStorage.setItem('preferred-language', language);
  
  console.log('🌐 RTL initialized:', {
    language,
    isRtl,
    direction: htmlElement.getAttribute('dir'),
    hasRtlClass: htmlElement.classList.contains('rtl-layout')
  });
  
  return isRtl;
};

// Utility hook for language management in components
export const useLanguageSetup = (propLanguage, propT) => {
  const [currentLanguage, setCurrentLanguage] = React.useState(() => {
    if (propLanguage) return propLanguage;
    const savedLanguage = localStorage.getItem('preferred-language');
    return savedLanguage || 'he';
  });

  const t = React.useCallback((key, fallback = null) => {
    if (propT) return propT(key, fallback);
    return getTranslation(key, currentLanguage, fallback);
  }, [propT, currentLanguage]);

  React.useEffect(() => {
    initializeRTL(currentLanguage);
  }, [currentLanguage]);

  React.useEffect(() => {
    if (propLanguage && propLanguage !== currentLanguage) {
      setCurrentLanguage(propLanguage);
    }
  }, [propLanguage]);

  return { currentLanguage, setCurrentLanguage, t };
};

// Level system specific utility functions
export const getLevelTitle = (level, language = 'he') => {
  const levelTitles = {
    1: 'מתחיל', 10: 'טירון', 20: 'בינוני', 30: 'מתקדם',
    40: 'מקצועי', 50: 'מומחה', 60: 'אמן', 70: 'אמן גדול',
    80: 'מיתי', 90: 'חכם', 100: 'אגדה'
  };
  
  // Find the appropriate title for the level
  const levelKeys = Object.keys(levelTitles).map(Number).sort((a, b) => b - a);
  
  for (const levelKey of levelKeys) {
    if (level >= levelKey) {
      return levelTitles[levelKey];
    }
  }
  
  return levelTitles[1]; // Default to beginner
};

export const getBadgeCategoryName = (category, language = 'he') => {
  const categoryNames = {
    'win_streak': 'רצף ניצחונות',
    'filler': 'מילוי',
    'total_wins': 'סך ניצחונות',
    'points_winning': 'נקודות מניצחונות',
    'points_purchase': 'רכישת נקודות',
    'multiplayer': 'מולטי פלייר',
    'battle_royale': 'בטל רויאל',
    'multiplayer_wins': 'ניצחונות מולטי פלייר',
    'battle_royale_wins': 'ניצחונות בטל רויאל'
  };
  
  return categoryNames[category] || category;
};

export const getRarityName = (rarity, language = 'he') => {
  const rarityNames = {
    'common': 'רגיל', 'rare': 'נדיר', 'epic': 'אפי', 'legendary': 'אגדי'
  };
  
  return rarityNames[rarity] || rarity;
};

// Add these utility functions for time formatting in cleanup contexts
export const formatCleanupTime = (milliseconds, language = 'he') => {
  const minutes = Math.floor(milliseconds / 60000);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  
  if (days > 0) {
    return `${days} ימים`;
  } else if (hours > 0) {
    return `${hours} שעות`;
  } else {
    return `${minutes} דקות`;
  }
};

export const formatCleanupAge = (createdAt, language = 'he') => {
  const now = new Date();
  const created = new Date(createdAt);
  const diffMs = now - created;
  
  return formatCleanupTime(diffMs, language);
};

export const getTimeUntilCleanup = (createdAt, maxAgeHours = 1, language = 'he') => {
  const now = new Date();
  const created = new Date(createdAt);
  const maxAgeMs = maxAgeHours * 60 * 60 * 1000;
  const ageMs = now - created;
  const remainingMs = maxAgeMs - ageMs;
  
  if (remainingMs <= 0) {
    return { expired: true, timeRemaining: 0 };
  }
  
  return {
    expired: false,
    timeRemaining: remainingMs,
    formatted: formatCleanupTime(remainingMs, language)
  };
  };

// Enhanced tournament age indicator component
export const TournamentAgeIndicator = ({ tournament, language, className = '' }) => {
  const age = formatCleanupAge(tournament.createdAt, language);
  const cleanup = getTimeUntilCleanup(tournament.createdAt, 1, language);
  
  if (cleanup.expired) {
    return (
      <div className={`tournament-age-indicator expired ${className}`}>
        <span className="age-icon">⏰</span>
        <span className="age-text">טורניר נמחק אוטומטית בגלל גיל</span>
      </div>
    );
  }
  
  const isWarning = cleanup.timeRemaining < 15 * 60 * 1000; // 15 minutes
  const isCritical = cleanup.timeRemaining < 5 * 60 * 1000; // 5 minutes
  
  return (
    <div className={`tournament-age-indicator ${isWarning ? 'warning' : ''} ${isCritical ? 'critical' : ''} ${className}`}>
      <span className="age-icon">⏰</span>
      <span className="age-text">
        גיל הטורניר: {age}
      </span>
      {isWarning && (
        <span className="cleanup-warning">
          מחיקה אוטומטית בעוד {cleanup.formatted}
        </span>
      )}
    </div>
  );};

export default hebrewTranslations;